<template>
  <SearchModal
    ref="SearchModal"
    class="searchTable"
    :type="searchData.type || 'post'"
    :API="searchData.API"
    :extraData="
      combineExtraData
        ? Object.assign(extraData, searchData.extraData)
        : extraData || searchData.extraData
    "
    :query="defaultQuery ? Object.assign(defaultQuery, searchData.query || {}) : searchData.query"
    :searchColumns="searchData.searchColumns"
    :columnList="searchData.columnList"
    :placeholder="placeholder || $t('search.choose')"
    :width="searchData.width || '800'"
    :propCode="searchData.propCode"
    :propName="propName || searchData.propName"
    :expandAll="searchData.expandAll"
    :currentValue="defaultValue"
    :checkRowKeys="checkRowKeys"
    :isMultiple="isMultiple"
    :isReadOnly="isReadOnly"
    :parseExtendMap="parseExtendMap"
    :placement="placement"
    :disabled="disabled"
    :trigger="trigger"
    :initShow="initShow"
    :isFixed="isFixed"
    :disableNoSearchData="searchData.disableNoSearchData"
    :options="searchData.options"
    :label-width="searchData.labelWidth || '90px'"
    @setSearchModal="setSearchModal"
    @setSearchModalInput="setSearchModalInput"
    @changeQuery="changeQuery"
  ></SearchModal>
</template>

<script>
  import XEUtils from 'xe-utils';

  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import GOODS_API from '@/api/masterData/goods';
  import OUTSIDE_PRICE from '@/api/masterData/outsidePrice';
  import COOPERATION_API from '@/api/masterData/cooperation';
  import COMPANY_API from '@/api/masterData/company';
  import PERSON_API from '@/api/masterData/personnel';
  import STORE_API from '@/api/storeMasterData';
  import API from '@/api/wareHouse/lossOverflowReport.js';
  // 物流调拨单
  import INVENTORYTRANSFER_API from '@/api/wareHouse/inventoryTransfer';
  import BATCH_API from '@/api/logisticsCenter/businessReceipt.js';
  import SUPPLY_API from '@/api/masterData/supplyChain';
  import SALE_API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import SETTLE_API from '@/api/capitalCenter/settle';
  import MULTRANSPORT_API from '@/api/intermodality/order.js';
  import BANK_API from '@/api/masterData/bank';
  import BANKACCOUNT_API from '@/api/financeCenter/bankAccount';
  import BASE_API from '@/api/dataBase';
  import PAY_INVOICE_API from '@/api/financeCenter/payables';
  import SALE_INVOICE_API from '@/api/financeCenter/saleInvoice';
  import PAYMENT_API from '@/api/financeCenter/paymentApply.js';
  // 票据
  import BILL_API from '@/api/capitalCenter/bill';
  // 信用证
  import LC_API from '@/api/capitalCenter/letterOfCredit';
  import PAYMENTED_API from '@/api/financeCenter/payment.js';
  // 日历
  import CALENDAR_API from '@/api/financeCenter/searchCalendar.js';
  //生产中心
  import PRODUCE_PRODUCT_API from '@/api/productCenter/rawData.js';
  //生产中心-物料配方
  import PRODUCE_FORMULA from '@/api/productCenter/prescriptionData.js';
  // 生产中心账期
  import PDPERIOD_API from '@/api/productCenter/pdPeriod';
  //期货策略
  import FUTURES_API from '@/api/futuresStrategy/index.js';
  // 退货批次号
  import PURCHASESALESCENTER_API from '@/api/purchaseSalesCenter/purchaseReturn.js';
  import AGENCYCONTRACT_API from '@/api/agencyContract/index.js';
  import PROJECTAPI from '@/api/intermodality/project';
  // import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import ProjectApi from '@/api/purchaseSalesCenter/project.js';
  import leaseContractApi from '@/api/park/leaseContract';
  // 报修单
  import REPAIRORDERAPI from '@/api/property/workorder';
  // 园区物业租赁合同
  import propertyLeaseApi from '@/api/property/leaseContract';
  // 监管合同立项
  import warehouseProjectApi from '@/api/park/project.js';
  // 仓储合同管理
  import warehouseContractApi from '@/api/park/contract.js';
  import superviseContractApi from '@/api/park/superviseContract';
  export default {
    // 制单人、商品描述、供应商、仓库 业务入库批次 弹窗搜索
    props: {
      searchType: {
        type: String,
        default: '',
      },
      //是否单选
      isMultiple: {
        type: Boolean,
        default: false,
      },
      isReadOnly: {
        type: Boolean,
        default: true,
      },
      currentValue: {
        type: String,
        default: '',
      },
      //默认选中
      checkRowKeys: {
        type: Array,
        default: () => [],
      },
      //额外参数
      extraData: {
        type: Object,
        default: () => {},
      },
      //列信息特殊判断使用
      columnExtra: {
        type: Object,
        default: () => {},
      },
      //默认传的propName
      propName: {
        type: String,
        default: '',
      },
      placement: {
        type: String,
        default: () => 'top',
      },
      //是否禁用
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      //是否允许多值输入查询
      isNeedMultipleValue: {
        type: Boolean,
        default: false,
      },
      //解析extendMap
      parseExtendMap: {
        type: Boolean,
        default: false,
      },
      // 点击方式
      trigger: {
        type: String,
        default: 'click',
      },
      // 传入的数据列表
      options: {
        type: Array,
        default: () => [],
      },
      // 是否默认初始化查询
      initShow: {
        type: Boolean,
        default: true,
      },
      combineExtraData: {
        type: Boolean,
        default: false,
      },
      isFixed: {
        type: Boolean,
        default: false,
      },
      isNeedCustomerName: {
        type: Boolean,
        default: false,
      },
      defaultQuery: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      SearchModal,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 动态获取当前属于什么搜索
      searchData() {
        const searchType = this.searchTypeClone;
        return this[searchType];
      },
      // 人员
      personnel() {
        return {
          width: '800',
          query: {
            personInfo: '',
          },
          API: PERSON_API.LIST_PERSONNEL,
          propCode: 'id',
          propName: 'personName', // 输入框展示内容
          extraData: {
            dataStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('personnel.search.personnelInformation'),
              prop: 'personInfo',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'personNo',
              label: this.$t('personnel.addpersonnel.personNo'),
              width: 100,
            },
            {
              prop: 'personName',
              label: this.$t('personnel.table.Name'),
              width: 100,
            },
            {
              prop: 'personCompanyName',
              label: this.$t('personnel.table.company'),
              width: 150,
            },
            {
              prop: 'personDepartmentName',
              label: this.$t('personnel.table.department'),
            },
            {
              prop: 'personMobilePhone',
              label: this.$t('personnel.table.phone'),
              width: 100,
            },
          ],
        };
      },
      route() {
        return {
          width: '800',
          query: {
            name: '',
          },
          API: PROJECTAPI.LIST_ROUTE,
          propCode: 'code',
          propName: 'name', // 输入框展示内容
          extraData: {},
          searchColumns: [
            {
              name: '线路名称',
              prop: 'name',
              type: 'input',
              maxlength: '50',
            },
          ],
          columnList: [
            {
              prop: 'code',
              label: '线路编码',
              width: 100,
            },
            {
              prop: 'name',
              label: '线路名称',
            },
          ],
        };
      },
      // 商品
      product() {
        const { adminFlag } = this.userInfo;
        return {
          query: {
            productChName: '',
          },
          API: GOODS_API.LIST_PRODUCT,
          propCode: 'parentProductNo',
          propName: 'productChName', // 输入框展示内容
          extraData: {
            parentProductStatus: 'ZT03',
            adminFlag,
          },
          searchColumns: [
            {
              name: this.$t('goods.search.productChName'),
              prop: 'productChName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'parentProductNo',
              label: this.$t('goods.table.parentProductNo'),
              width: 180,
            },
            {
              prop: 'productChName',
              label: this.$t('goods.table.productChName'),
            },
            {
              prop: 'productEnName',
              label: this.$t('goods.table.productEnName'),
              width: 180,
            },
          ],
        };
      },
      // wumaoFix商品
      usableProduct() {
        return {
          query: {
            productChName: '',
          },
          width: '800',
          API: '/maindata/product/listUsableProductByPage',
          propCode: 'parentProductNo',
          propName: 'productChName', // 输入框展示内容
          searchColumns: [
            {
              name: this.$t('goods.search.productChName'),
              prop: 'productChName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'parentProductNo',
              label: '商品父类编码',
              width: 180,
            },
            {
              prop: 'productDetailCode',
              label: '商品子类编码',
              width: 180,
            },
            {
              prop: 'productChName',
              label: this.$t('goods.table.productChName'),
              width: 180,
            },
            {
              prop: 'detailProductModel',
              label: '规格',
              width: 180,
            },
            {
              prop: 'detailProductMaterial',
              label: '材料',
              width: 180,
            },
          ],
        };
      },
      // 商品类型
      productType() {
        const { adminFlag } = this.userInfo;
        return {
          query: {
            productName: '',
          },
          API: GOODS_API.LIST_PRODUCT,
          propCode: 'groupCategory',
          propName: 'groupCategoryName', // 输入框展示内容
          extraData: {
            parentProductStatus: 'ZT03',
            adminFlag,
          },
          searchColumns: [
            {
              name: this.$t('goods.search.productChName'),
              prop: 'productChName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'parentProductNo',
              label: this.$t('goods.table.parentProductNo'),
              width: 180,
            },
            {
              prop: 'groupCategoryName',
              label: '商品分类',
            },
            {
              prop: 'productChName',
              label: '商品名称',
            },
          ],
        };
      },
      // 仓库
      warehouse() {
        return {
          width: '800',
          API: COMPANY_API.GET_STORAGE_LIST,
          propName: 'storageName', // 输入框展示内容
          propCode: 'storageCode',
          query: {
            storageCode: '',
            storageName: '',
            currentStatus: 'ZT03',
          },
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
              width: '190px',
            },
            {
              prop: 'companyName',
              label: '仓库公司',
              width: '190px',
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
              width: '190px',
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
              width: '180px',
            },
          ],
        };
      },
      // 仓库公司
      warehouseCompany() {
        return {
          width: '800',
          API: COMPANY_API.GET_STORAGE_LIST,
          propName: 'companyName', // 输入框展示内容
          propCode: 'companyCode',
          query: {
            storageCode: '',
            storageName: '',
            currentStatus: 'ZT03',
          },
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
            },
            {
              prop: 'companyName',
              label: '仓库公司',
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
          ],
        };
      },
      // 仓库(采销专用)
      warehouseDirectDeliver() {
        return {
          width: '800',
          API: COMPANY_API.GET_STORAGE_LIST,
          propName: 'storageName', // 输入框展示内容
          propCode: 'storageCode',
          query: {
            storageCode: '',
            storageName: '',
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('warehouse.search.warehouseCode'),
              prop: 'storageCode',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('warehouse.search.warehouseName'),
              prop: 'storageName',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('warehouse.table.isDirectDeliver'),
              prop: 'isDirectDeliver',
              type: 'select',
              placeholder: this.$t('warehouse.search.isDirectDeliverPlaceholder'),
              options: [
                {
                  label: '是',
                  value: 1,
                },
                {
                  label: '否',
                  value: 0,
                },
              ],
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: this.$t('warehouse.table.createWarehouseCode'),
              width: 150,
            },
            {
              prop: 'storageName',
              label: this.$t('warehouse.table.createWarehouseName'),
            },
            {
              prop: 'isDirectDeliver',
              label: this.$t('warehouse.table.isDirectDeliver'),
              formatter: this.formatterisDirectDeliver,
              width: 80,
            },
            {
              prop: 'storageAddress',
              label: this.$t('warehouse.table.createWarehouseAddress'),
            },
          ],
        };
      },
      // 物流调拨单
      inventoryTransfer() {
        return {
          width: '800',
          API: INVENTORYTRANSFER_API.GET_LIST_API,
          propName: 'allotNo', // 输入框展示内容
          propCode: 'allotNo',
          query: {
            allotNo: '',
            currentStatus: 'ZT03',
          },
          extraData: {
            adminFlag: this.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: '库存调拨单号',
              prop: 'allotNo',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'allotNo',
              label: '库存调拨单号',
            },
            {
              prop: 'allotOutStorage',
              label: '调出仓库',
            },
            {
              prop: 'allotInStorage',
              label: '调入仓库',
            },
          ],
        };
      },
      // 合作伙伴-不过滤重复的
      partnerNoFilter() {
        // const { adminFlag } = this.userInfo;
        return {
          query: {
            partnerZhName: '',
            partnerCode: '',
            searchCode: '',
          },
          API: COOPERATION_API.LIST_PARTNEREXTEND_NO_FILTER, // 合作伙伴：供应商类型
          disableNoSearchData: true, // 禁止没有查询条件搜索
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerZhName'),
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              prop: 'partnerCode',
              name: this.$t('cooperation.label.partnerCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerCode'),
            },
            {
              prop: 'searchCode',
              name: this.$t('cooperation.label.searchCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.searchCode'),
            },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerZhName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerCode'),
            },
            {
              prop: 'searchCode',
              label: this.$t('cooperation.label.searchCode'),
            },
            {
              prop: 'partnerType',
              label: '合作伙伴类型',
              formatter: this.formatterPartnerType,
            },
            {
              prop: 'departmentName',
              label: '部门',
            },
          ],
        };
      },
      // 合作伙伴
      partner() {
        // const { adminFlag } = this.userInfo;
        return {
          width: '800',
          query: {
            partnerZhName: '',
            partnerCode: '',
            searchCode: '',
          },
          API: COOPERATION_API.LIST_PARTNEREXTEND, // 合作伙伴：供应商类型
          disableNoSearchData: true, // 禁止没有查询条件搜索
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerZhName'),
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              prop: 'partnerCode',
              name: this.$t('cooperation.label.partnerCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerCode'),
            },
            {
              prop: 'ifPersonalPartner',
              name: '是否个人合作伙伴',
              type: 'select',
              options: [
                {
                  value: '0',
                  label: '否',
                },
                {
                  value: '1',
                  label: '是',
                },
              ],
            },
            // {
            //   prop: 'searchCode',
            //   name: this.$t('cooperation.label.searchCode'),
            //   type: 'input',
            //   placeholder: this.$t('cooperation.placeholder.searchCode'),
            // },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerZhName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerCode'),
            },
            // {
            //   prop: 'searchCode',
            //   label: this.$t('cooperation.label.searchCode'),
            // },
            /*  {
            prop: "partnerType",
            label: '合作伙伴类型',
            formatter: this.formatterPartnerType
          },
          {
            prop: "departmentName",
            label: '部门',
          }, */
          ],
          labelWidth: '110px',
        };
      },
      partnerCollectBill() {
        return {
          width: '800',
          query: {
            partnerZhName: '',
            partnerCode: '',
            searchCode: '',
          },
          API: COOPERATION_API.LIST_PARTNEREXTEND, // 合作伙伴：供应商类型
          disableNoSearchData: true, // 禁止没有查询条件搜索
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerZhName'),
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              prop: 'partnerCode',
              name: this.$t('cooperation.label.partnerCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerCode'),
            },
            {
              prop: 'ifPersonalPartner',
              name: '是否个人合作伙伴',
              type: 'select',
              options: [
                {
                  value: '0',
                  label: '否',
                },
                {
                  value: '1',
                  label: '是',
                },
              ],
            },
            // {
            //   prop: 'searchCode',
            //   name: this.$t('cooperation.label.searchCode'),
            //   type: 'input',
            //   placeholder: this.$t('cooperation.placeholder.searchCode'),
            // },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerZhName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerCode'),
            },
            {
              prop: 'partnerType',
              label: '合作伙伴类型',
              formatter: this.formatterPartnerType,
            },
            // {
            //   prop: 'searchCode',
            //   label: this.$t('cooperation.label.searchCode'),
            // },
            /*  {
            prop: "partnerType",
            label: '合作伙伴类型',
            formatter: this.formatterPartnerType
          },
          {
            prop: "departmentName",
            label: '部门',
          }, */
          ],
          labelWidth: '110px',
        };
      },
      // 供应商
      supplier() {
        // const { adminFlag } = this.userInfo;
        return {
          width: '800',
          query: {
            partnerZhName: '',
            partnerCode: '',
            searchCode: '',
            partnerTypes: 'HZHB02,HZHB03',
          },
          API: COOPERATION_API.LIST_PARTNEREXTEND, // 合作伙伴：供应商类型
          disableNoSearchData: true, // 禁止没有查询条件搜索
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerZhName'),
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              prop: 'partnerCode',
              name: this.$t('cooperation.label.partnerCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerCode'),
            },
            {
              prop: 'ifPersonalPartner',
              name: '是否个人合作伙伴',
              type: 'select',
              options: [
                {
                  value: '0',
                  label: '否',
                },
                {
                  value: '1',
                  label: '是',
                },
              ],
            },
            // {
            //   prop: 'partnerZhName',
            //   name: this.$t('cooperation.label.partnerZhName'),
            //   type: 'input',
            //   placeholder: this.$t('cooperation.placeholder.partnerZhName'),
            //   maxlength: '30',
            //   isNeedMultipleValue: this.isNeedMultipleValue,
            // },
            // {
            //   prop: 'partnerCode',
            //   name: this.$t('cooperation.label.partnerCode'),
            //   type: 'input',
            //   placeholder: this.$t('cooperation.placeholder.partnerCode'),
            // },
            // // {
            // //   prop: 'searchCode',
            // //   name: this.$t('cooperation.label.searchCode'),
            // //   type: 'input',
            // //   placeholder: this.$t('cooperation.placeholder.searchCode'),
            // // },
            // {
            //   prop: 'ifPersonalPartner',
            //   name: '是否个人合作伙伴',
            //   type: 'select',
            //   options: [
            //     {
            //       value: '0',
            //       label: '否',
            //     },
            //     {
            //       value: '1',
            //       label: '是',
            //     },
            //   ],
            // },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerZhName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerCode'),
            },
            // {
            //   prop: 'searchCode',
            //   label: this.$t('cooperation.label.searchCode'),
            // },
            {
              prop: 'partnerType',
              label: '合作伙伴类型',
              formatter: this.formatterPartnerType,
            },
            {
              prop: 'departmentName',
              label: '部门',
            },
          ],
        };
      },
      // 合作伙伴：客户类型
      customer() {
        // const { adminFlag } = this.userInfo;
        return {
          query: {
            partnerZhName: '',
            partnerCode: '',
            searchCode: '',
            partnerTypes: 'HZHB01,HZHB03',
          },
          API: COOPERATION_API.LIST_PARTNEREXTEND, // 合作伙伴：客户类型
          disableNoSearchData: true, // 禁止没有查询条件搜索
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerZhName'),
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              prop: 'partnerCode',
              name: this.$t('cooperation.label.partnerCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerCode'),
            },
            {
              prop: 'searchCode',
              name: this.$t('cooperation.label.searchCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.searchCode'),
            },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerZhName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerCode'),
            },
            {
              prop: 'searchCode',
              label: this.$t('cooperation.label.searchCode'),
            },
            {
              prop: 'partnerType',
              label: '合作伙伴类型',
              formatter: this.formatterPartnerType,
            },
            {
              prop: 'departmentName',
              label: '部门',
            },
          ],
        };
      },
      // 供应商sap
      sapSupplier() {
        const { adminFlag } = this.userInfo;
        return {
          query: {
            partnerZhName: '',
          },
          API: BASE_API.GET_SPAPARTNER, // 合作伙伴：供应商类型
          propName: 'partnerCode', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {
            // partnerType: "HZHB02",
            partnerTypeList: ['HZHB02', 'HZHB03'],
            requestStatus: 'ZT03',
            distinctFlag: true,
            adminFlag,
          },
          searchColumns: [
            {
              name: this.$t('contractAgency.partnerZhName'),
              prop: 'partnerZhName',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('contractAgency.partnerZhName'),
            },
            { prop: 'partnerCode', label: this.$t('contractAgency.partnerCode') },
            { prop: 'sapPartnerCode', label: 'sap合作伙伴代码' },
          ],
        };
      },
      // 客户sap
      sapCustomer() {
        const { adminFlag } = this.userInfo;
        return {
          query: {
            partnerZhName: '',
          },
          API: BASE_API.GET_SPAPARTNER, // 合作伙伴：客户类型
          propName: 'partnerCode', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {
            requestStatus: 'ZT03',
            // partnerType: this.extraData ? this.extraData.partnerType : "HZHB01",
            partnerTypeList: ['HZHB01', 'HZHB03'],
            distinctFlag: true,
            adminFlag,
          },
          searchColumns: [
            {
              name: this.$t('contractAgency.partnerZhName'),
              prop: 'partnerZhName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('contractAgency.partnerZhName'),
            },
            { prop: 'partnerCode', label: this.$t('contractAgency.partnerCode') },
            { prop: 'sapPartnerCode', label: 'sap合作伙伴代码' },
          ],
        };
      },
      // 业务入库单批次
      inboundNewNo() {
        return {
          query: {
            productName: null,
            contractInternalNo: null,
            batchNo: null,
            storageName: null,
            partnerName: null,
            productDetailNo: null,
          },
          extraData: {},
          API: API.GET_INBOUND_NEW,
          searchColumns: [
            {
              prop: 'productName',
              name: this.$t('businessReceiptList.search.productName'),
              type: 'input',
            },
            {
              prop: 'contractInternalNo',
              name: this.$t('businessReceiptList.search.contractInternalNo'),
              type: 'input',
            },
            {
              prop: 'batchNo',
              name: this.$t('businessReceiptList.search.batchNo'),
              type: 'input',
            },
            {
              prop: 'storageName',
              name: this.$t('businessReceiptList.search.storageName'),
              type: 'input',
            },
            {
              prop: 'partnerName',
              name: this.$t('businessReceiptList.search.partnerName'),
              type: 'input',
            },
            {
              prop: 'productDetailNo',
              name: this.$t('businessReceiptList.search.productDetailNo'),
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'batchNo',
              label: this.$t('businessReceiptList.search.incomingBatch'),
              fixed: 'left',
              width: 140,
            },
            {
              prop: 'storageQuantity',
              label: this.$t('businessReceiptList.table.storageQuantity'),
              fixed: 'left',
              width: 100,
            },
            { prop: 'availableQuantity', label: '可用库存数量', fixed: 'left', width: 100 },
            { prop: 'storageName', label: this.$t('businessReceiptList.search.storageName') },
            {
              prop: 'productName',
              label: this.$t('businessReceiptList.search.productName'),
              width: 120,
            },
            { prop: 'gmtCreate', label: this.$t('businessReceiptList.table.gmtCreate') },
            { prop: 'businessInboundNo', label: this.$t('businessReceiptList.table.inboundNo') },
            {
              prop: 'contractInternalNo',
              label: this.$t('businessReceiptList.search.contractInternalNo'),
            },
            { prop: 'storagePrice', label: '库存实时单价' },
            { prop: 'inboundCompanyWithouttaxPrice', label: '本币入库不含税单价' },
            { prop: 'partnerName', label: this.$t('businessReceiptList.search.partnerName') },
            { prop: 'storageName', label: '仓库' },
          ],
        };
      },
      // 合作伙伴：仓储服务
      warsehouseService() {
        //const { adminFlag } = this.userInfo;
        return {
          query: {
            partnerZhName: '',
            partnerCode: '',
            searchCode: '',
            partnerTypes: 'HZHB07',
          },
          API: COOPERATION_API.LIST_PARTNEREXTEND, // 合作伙伴：客户类型
          disableNoSearchData: true, // 禁止没有查询条件搜索
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'partnerZhName',
              name: this.$t('cooperation.label.partnerZhName'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerZhName'),
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              prop: 'partnerCode',
              name: this.$t('cooperation.label.partnerCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.partnerCode'),
            },
            {
              prop: 'searchCode',
              name: this.$t('cooperation.label.searchCode'),
              type: 'input',
              placeholder: this.$t('cooperation.placeholder.searchCode'),
            },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerZhName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerCode'),
            },
            {
              prop: 'searchCode',
              label: this.$t('cooperation.label.searchCode'),
            },
            {
              prop: 'partnerType',
              label: '合作伙伴类型',
              formatter: this.formatterPartnerType,
            },
            {
              prop: 'departmentName',
              label: '部门',
            },
          ],
        };
      },
      // 所属集团
      partnerParent() {
        // const { departmentCode } = this.userInfo;
        return {
          query: {
            partnerZhName: '',
          },
          type: 'post',
          API: COOPERATION_API.LIST_PARTNERCODENAME, // 合作伙伴：所属集团
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          extraData: this.extraData || {
            partnerZhName: '',
          },
          searchColumns: [
            {
              name: this.$t('cooperation.label.partnerParentCompany'),
              prop: 'partnerZhName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'partnerZhName',
              label: this.$t('cooperation.label.partnerParentCompanyName'),
            },
            {
              prop: 'partnerCode',
              label: this.$t('cooperation.label.partnerParentCompanyCode'),
            },
          ],
        };
      },
      //商品子类
      goodsDetail() {
        return {
          width: '800',
          query: {
            detailProductDisplayName: null,
            productDetailCode: null,
            detailProductStatus: 'ZT03',
          },
          API: GOODS_API.LIST_DETAIL_PRODUCT,
          extraData: {
            //已生效
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propCode: 'productDetailCode',
          propName: 'productChName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: this.$t('goods.search.productDetailCode'),
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('goods.search.detailProductDisplayName'),
              prop: 'productChName',
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: this.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'productChName',
              label: this.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductModel',
              label: this.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
      //销售提单 供应商发货至零 商品类
      goodsSaleDetail() {
        return {
          width: '800',
          query: {
            detailProductDisplayName: null,
            productDetailCode: null,
            detailProductStatus: 'ZT03',
          },
          API: GOODS_API.LIST_PRODUCT,
          extraData: {
            //已生效
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propCode: 'productDetailCode',
          propName: 'productChName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: this.$t('goods.search.productDetailCode'),
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('goods.search.detailProductDisplayName'),
              prop: 'productChName',
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: this.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'productChName',
              label: this.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductModel',
              label: this.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
      //多式联运合同商品查询
      goodsIntermodalityContractParent() {
        return {
          width: '800',
          query: {
            productChName: null,
            productParentCode: null,
          },
          API: '/sales/mto/contract/getAllCargoList',
          propCode: 'parentProductNo',
          propName: 'productChName', // 输入框展示内容
          searchColumns: [
            {
              name: this.$t('goods.search.productChName'),
              prop: 'productParentName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'productParentCode',
              label: this.$t('goods.table.parentProductNo'),
              width: 180,
            },
            {
              prop: 'productParentName',
              label: this.$t('goods.table.productChName'),
            },
          ],
        };
      },
      //商品所有子类
      goodsIntermodalityContractDetail() {
        return {
          width: '1000',
          query: {
            productChName: null,
            productDetailCode: null,
            detailProductStatus: 'ZT03',
          },
          API: '/sales/mto/contract/getAllCargoList',
          propCode: 'productDetailCode',
          propName: 'productParentName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: this.$t('goods.search.productDetailCode'),
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('goods.search.detailProductDisplayName'),
              prop: 'productParentName',
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: this.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'productParentName',
              label: this.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductItems',
              label: '品目',
            },
            {
              prop: 'detailProductModel',
              label: this.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
      //商品所有子类
      goodsAllCategory() {
        return {
          width: '800',
          query: {
            productChName: null,
            productDetailCode: null,
            detailProductStatus: 'ZT03',
          },
          API: GOODS_API.GOODS_CATEGORY_API,
          extraData: {
            //已生效
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propCode: 'productDetailCode',
          propName: 'productChName',
          searchColumns: [
            {
              prop: 'productDetailCode',
              name: this.$t('goods.search.productDetailCode'),
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('goods.search.detailProductDisplayName'),
              prop: 'productChName',
              type: 'input',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'productDetailCode',
              label: this.$t('goods.table.productDetailCode'),
              width: 200,
            },
            {
              prop: 'productChName',
              label: this.$t('goods.table.detailProductDisplayName'),
              width: 200,
            },
            {
              prop: 'detailProductModel',
              label: this.$t('goods.table.detailProductModel'),
            },
          ],
        };
      },
      //所有商品
      goodsAll() {
        return {
          width: '800',
          query: {
            productChName: null,
            adminFlag: null,
            selectCompanyCode: null,
            detailProductStatus: 'ZT03',
          },
          API: OUTSIDE_PRICE.LIST_PRODUCT_ALL,
          extraData: {
            //已生效
            detailProductStatus: 'ZT03',
            adminFlag: this.userInfo.adminFlag,
            selectCompanyCode: this.userInfo.companyCode,
          },
          propName: 'detailProductDisplayName',
          searchColumns: [
            {
              prop: 'productChName',
              name: this.$t('outsidePrice.label.detailProductDisplayName'),
              type: 'input',
              placeholder: this.$t('outsidePrice.placeholder.detailProductDisplayName'),
              maxlength: '32',
            },
          ],
          columnList: [
            { prop: 'detailProductDisplayName', label: this.$t('outsidePrice.label.showName') },
            { prop: 'productChName', label: this.$t('outsidePrice.label.ZHName') },
            { prop: 'productDetailCode', label: this.$t('outsidePrice.label.productCode') },
            {
              prop: 'detailProductStatusName',
              label: this.$t('outsidePrice.label.productStatus_st'),
            },
          ],
        };
      },
      // 退货批次号
      storageBatchForPurchaseReturn() {
        return {
          width: '800',
          query: {},
          API: PURCHASESALESCENTER_API.GET_STORAGEFORPURCHASERETURN_PAGE,
          propCode: 'batchNo',
          propName: 'batchNo',
          searchColumns: [
            {
              prop: 'batchNo',
              name: '退货批次号',
              type: 'input',
            },
          ],
          columnList: [
            { prop: 'batchNo', label: '退货批次号', fixed: 'left', width: 140 },
            { prop: 'originalBatchNo', label: '业务批次号', fixed: 'left', width: 140 },
            { prop: 'storageQuantity', label: '库存数量', fixed: 'left', width: 100 },
            { prop: 'availableQuantity', label: '可用库存数量', fixed: 'left', width: 100 },
            { prop: 'storageName', label: '仓库名称' },
            { prop: 'matchedQuantity', label: '已匹配数量' },
            { prop: 'productName', label: '商品名称', width: 120 },
          ],
        };
      },
      // 业务入库批次
      warehouseBatch() {
        return {
          width: '800',
          query: {
            tenantCode: this.userInfo.tenantCode,
            companyCode: this.userInfo.companyCode,
            inboundStatus: '02',
            inboundType: '0',
            productName: null,
            startGmtCreate: null,
            endGmtCreate: null,
            contractInternalNo: null,
            batchNo: null,
            storageName: null,
            partnerName: null,
            marineLadingNo: null,
            warehouseReceiptsNo: null,
            settleBatchNo: null,
            productDetailNo: null,
            nameVoyageLicense: null,
            distributionBatchNo: null,
          },
          API: API.LIST_INBOUND,
          propCode: 'batchNo',
          propName: 'batchNo',
          searchColumns: [
            {
              prop: 'productName',
              name: this.$t('businessReceiptList.search.productName'),
              type: 'input',
            },
            {
              prop: 'startGmtCreate',
              name: this.$t('businessReceiptList.search.startGmtCreate'),
              type: 'startDaterangePicker',
            },
            {
              prop: 'endGmtCreate',
              name: this.$t('businessReceiptList.search.endGmtCreate'),
              type: 'endDaterangePicker',
            },
            {
              prop: 'contractInternalNo',
              name: this.$t('businessReceiptList.search.contractInternalNo'),
              type: 'input',
            },
            {
              prop: 'batchNo',
              name: this.$t('businessReceiptList.search.batchNo'),
              type: 'input',
            },
            {
              prop: 'storageName',
              name: this.$t('businessReceiptList.search.storageName'),
              type: 'input',
            },
            {
              prop: 'partnerName',
              name: this.$t('businessReceiptList.search.partnerName'),
              type: 'input',
            },
            {
              prop: 'marineLadingNo',
              name: this.$t('businessReceiptList.search.marineLadingNo'),
              type: 'input',
            },
            {
              prop: 'warehouseReceiptsNo',
              name: this.$t('businessReceiptList.search.warehouseReceiptsNo'),
              type: 'input',
            },
            {
              prop: 'settleBatchNo',
              name: this.$t('businessReceiptList.search.settleBatchNo'),
              type: 'input',
            },
            {
              prop: 'productDetailNo',
              name: this.$t('businessReceiptList.search.productDetailNo'),
              type: 'input',
            },
            {
              prop: 'nameVoyageLicense',
              name: this.$t('businessReceiptList.search.nameVoyageLicense'),
              type: 'input',
            },
            {
              type: 'input',
              prop: 'distributionBatchNo',
              name: this.$t('logistics.commodityMarket.distributionBatchNo'),
            },
          ],
          columnList: [
            {
              prop: 'batchNo',
              label: this.$t('businessReceiptList.search.incomingBatch'),
              fixed: 'left',
              width: 140,
            },
            {
              prop: 'storageQuantity',
              label: this.$t('businessReceiptList.table.storageQuantity'),
              fixed: 'left',
              width: 100,
            },
            { prop: 'availableQuantity', label: '可用库存数量', fixed: 'left', width: 100 },
            { prop: 'storageName', label: this.$t('businessReceiptList.search.storageName') },
            {
              prop: 'productName',
              label: this.$t('businessReceiptList.search.productName'),
              width: 120,
            },
            { prop: 'gmtCreate', label: this.$t('businessReceiptList.table.gmtCreate') },
            { prop: 'inboundNo', label: this.$t('businessReceiptList.table.inboundNo') },
            {
              prop: 'contractInternalNo',
              label: this.$t('businessReceiptList.search.contractInternalNo'),
            },
            {
              prop: 'businessUnitPriceWithTax',
              label: this.$t('businessReceiptList.table.businessUnitPriceWithTax'),
            },
            {
              prop: 'financeUnitPriceWithTax',
              label: this.$t('businessReceiptList.table.financeUnitPriceWithTax'),
            },
            { prop: 'partnerName', label: this.$t('businessReceiptList.search.partnerName') },
            { prop: 'marineLadingNo', label: this.$t('businessReceiptList.search.marineLadingNo') },
            {
              prop: 'warehouseReceiptsNo',
              label: this.$t('businessReceiptList.search.warehouseReceiptsNo'),
            },
            { prop: 'settleBatchNo', label: this.$t('businessReceiptList.search.settleBatchNo') },
            {
              prop: 'nameVoyageLicense',
              label: this.$t('businessReceiptList.search.nameVoyageLicense'),
            },
            {
              prop: 'distributionBatchNo',
              label: this.$t('logistics.commodityMarket.distributionBatchNo'),
            },
          ],
        };
      },
      // 供应链主体
      supplychain() {
        const { adminFlag } = this.userInfo;
        return {
          query: {
            supplierName: '',
            supplierCode: '',
            searchCode: '',
            distinctFlag: true,
          },
          API: SUPPLY_API.LIST_SUPPLIERS, // 供应链主体
          propName: 'supplierName', // 输入框展示内容
          propCode: 'supplierCode',
          extraData: {
            adminFlag: adminFlag,
            tenantCode: this.userInfo.tenantCode,
            companyCode: this.userInfo.companyCode,
            departmentCode: this.userInfo.departmentCode,
            requestStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.supplychainName'),
              prop: 'supplierName',
              type: 'input',
              maxlength: '32',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
            {
              name: this.$t('salePurchase.search.supplychainNo'),
              prop: 'supplierCode',
              type: 'input',
            },
            {
              prop: 'searchCode',
              name: '搜索简码',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'supplierName',
              label: this.$t('salePurchase.search.supplychainName'),
            },
            {
              prop: 'supplierCode',
              label: this.$t('salePurchase.search.supplychainNo'),
            },
            {
              prop: 'searchCode',
              label: '搜索简码',
            },
          ],
        };
      },
      commonContract() {
        let businessCategory = this.extraData.businessCategory;
        let purchaseOrSale = this.extraData.contractCategory;
        let columnList = [];
        let searchItems = [
          {
            name: '合同编号',
            prop: 'contractNoLike',
            type: 'input',
          },
          ...(this.isNeedCustomerName
            ? [
                {
                  name: '客户名称',
                  prop: 'customerName',
                  type: 'input',
                },
              ]
            : []),
        ];
        let statusList = [];

        switch (businessCategory) {
          //贸易
          case '01':
            if (purchaseOrSale == 'purchase') {
              searchItems = [
                {
                  name: '合同编号',
                  prop: 'contractNoLike',
                  type: 'input',
                },
                {
                  name: '合同行项目编号',
                  prop: 'contractDetailNo',
                  type: 'input',
                },
              ];
              columnList = [
                {
                  prop: 'contractNo',
                  label: '采购合同编号',
                  width: 120,
                },
                {
                  prop: 'externalContractNo',
                  label: '外部合同编号',
                  width: 120,
                },
                {
                  prop: 'contractDetailNo',
                  label: '合同行项目编号',
                  width: 80,
                },
                {
                  prop: 'productDesc',
                  label: '商品描述',
                  width: 200,
                },
                {
                  prop: 'productQuantity',
                  label: '数量',
                  width: 100,
                },
                {
                  prop: 'businessContractUnitPrice',
                  label: '单价',
                  width: 100,
                },
              ];
            } else {
              columnList = [
                {
                  prop: 'contractNo',
                  label: '销售合同编号',
                  width: 120,
                },
                {
                  prop: 'externalContractNo',
                  label: '外部合同编号',
                  width: 120,
                },
                {
                  prop: 'contractDetailNo',
                  label: '合同行项目编号',
                  width: 80,
                },
                {
                  prop: 'productDesc',
                  label: '商品描述',
                  width: 200,
                },
                {
                  prop: 'productQuantity',
                  label: '数量',
                  width: 100,
                },
                {
                  prop: 'businessContractUnitPrice',
                  label: '单价',
                  width: 100,
                },
              ];

              if (this.columnExtra?.type == 'collectBillTable') {
                columnList = [
                  {
                    prop: 'contractNo',
                    label: '销售合同编号',
                    width: 200,
                  },
                  {
                    prop: 'contractDetailCategoryName',
                    label: '制单类型',
                    width: 200,
                  },
                  {
                    prop: 'contractCreateDate',
                    label: '制单日期',
                    width: 200,
                  },
                ];
              }
            }
            statusList.push('ZT03');
            break;
          case '02':
            //多式联运
            // statusList.push('ZT03');
            if (purchaseOrSale == 'purchase') {
              columnList = [
                {
                  prop: 'contractNo',
                  label: '供方合同编号',
                  width: 120,
                },
                {
                  prop: 'contractName',
                  label: '合同名称',
                  width: 200,
                },
                {
                  prop: 'contractSignDate',
                  label: '合同签订时间',
                  width: 200,
                  formatter: this.formatterDate,
                },
                {
                  prop: 'contractStatus',
                  label: '合同状态',
                  width: 80,
                  formatter: this.formatterIntermodalityContractStatus,
                },
              ];
            } else {
              columnList = [
                {
                  prop: 'contractNo',
                  label: '客户合同编号',
                  width: 120,
                },
                {
                  prop: 'contractName',
                  label: '合同名称',
                  width: 200,
                },
                {
                  prop: 'contractSignDate',
                  label: '合同签订时间',
                  width: 120,
                  formatter: this.formatterDate,
                },
                {
                  prop: 'contractStatus',
                  label: '合同状态',
                  width: 80,
                  formatter: this.formatterIntermodalityContractStatus,
                },
              ];
            }
            break;
          case '03':
            //园区物业
            // statusList.push('02');
            columnList = [
              {
                prop: 'contractNo',
                label: '租赁合同编号',
              },
              {
                prop: 'contractName',
                label: '合同名称',
              },
              ...(this.isNeedCustomerName
                ? [{ prop: 'customerName', label: '客户名称', width: 120 }]
                : []),
              {
                prop: 'gmtCreate',
                label: '合同创建时间',
                formatter: this.formatterDate,
              },
              {
                prop: 'contractStatus',
                label: '合同状态',
                formatter: this.formatterLeaseContractStatus,
              },
            ];
            break;
          case '04':
            //三方租赁
            statusList.push('03');
            columnList = [
              {
                prop: 'contractNo',
                label: '三方仓库合同号',
                width: 120,
              },
              {
                prop: 'paperContractNo',
                label: '外部合同号',
                width: 120,
              },
              {
                prop: 'contractStatus',
                label: '合同状态',
                width: 80,
                formatter: this.formatterThirdPartyContractStatus,
              },
            ];
            break;
          case '05':
            //仓储合同
            statusList.push('ZT03');
            columnList = [
              {
                prop: 'contractNo',
                label: '合同号',
                width: 120,
              },
              {
                prop: 'externalContractNo',
                label: '外部合同号',
                width: 120,
              },
              ...(this.isNeedCustomerName
                ? [{ prop: 'customerName', label: '客户名称', width: 120 }]
                : []),
              {
                prop: 'contractDetailNo',
                label: '合同行项目编号',
                width: 80,
              },
              {
                prop: 'productDesc',
                label: '商品描述',
                width: 200,
              },
              {
                prop: 'productQuantity',
                label: '数量',
                width: 100,
              },
              {
                prop: 'businessContractUnitPrice',
                label: '单价',
                width: 100,
              },
            ];
            break;
          case '06':
            //监管合同
            statusList.push('03');
            columnList = [
              {
                prop: 'contractNo',
                label: '合同号',
                width: 120,
              },
              {
                prop: 'externalContractNo',
                label: '外部合同号',
                width: 120,
              },
              {
                prop: 'contractDetailNo',
                label: '合同行项目编号',
                width: 80,
              },
              {
                prop: 'productDesc',
                label: '商品描述',
                width: 200,
              },
              {
                prop: 'productQuantity',
                label: '数量',
                width: 100,
              },
              {
                prop: 'businessContractUnitPrice',
                label: '单价',
                width: 100,
              },
            ];
            break;
        }

        return {
          width: '800',
          query: {
            contractNoLike: null,
            contractDetailNo: null,
          },
          API: '/sales/common/contract/page',
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            statusList: statusList,
            businessCategory: businessCategory,
          },
          searchColumns: searchItems,
          columnList: columnList,
        };
      },
      // 合同
      contract() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: SALE_API.GET_LIST_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('salePurchase.search.contractNo'),
              width: 266,
            },
            {
              prop: 'contractDetailCategoryName',
              label: this.$t('salePurchase.search.contractCategory'),
              width: 266,
            },
            {
              prop: 'contractCreateDate',
              label: this.$t('salePurchase.table.contractCreateDate'),
              width: 266,
            },
          ],
        };
      },
      wumaoContract() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: '/sales/wm/order/listOrderByPage',
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
            {
              name: '外部合同号',
              prop: 'externalContractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('salePurchase.search.contractNo'),
              width: 200,
            },
            {
              prop: 'contractDetailCategoryName',
              label: this.$t('salePurchase.search.contractCategory'),
              width: 200,
            },
            {
              prop: 'contractCreateDate',
              label: this.$t('salePurchase.table.contractCreateDate'),
              width: 200,
            },
            {
              prop: 'externalContractNo',
              label: '外部合同号',
              width: 200,
            },
          ],
        };
      },
      // 第三方租赁合同
      leaseContract() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: leaseContractApi.GET_PAGE,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: '03',
          },
          searchColumns: [
            {
              name: '合同编号',
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同编号',
              width: 120,
            },
            {
              prop: 'signDate',
              label: '签约日期',
              width: 120,
            },
            {
              prop: 'signPlace',
              label: '签约地点',
              width: 120,
            },
            {
              prop: 'signPerson',
              label: '签约人',
              width: 120,
            },
            {
              prop: 'leaseDateFrom',
              label: '租赁开始日期',
              width: 120,
            },
            {
              prop: 'leaseDateUnit',
              label: '租赁结束日期',
            },
          ],
        };
      },
      // 监管单合同
      superviseContract() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: superviseContractApi.GET_PAGE_DATA,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: '03',
          },
          searchColumns: [
            {
              name: '合同编号',
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同编号',
              width: 120,
            },
            {
              prop: 'paperContractNo',
              label: '纸质合同号',
            },
            {
              prop: 'signDate',
              label: '签约日期',
              width: 120,
            },
            {
              prop: 'signPerson',
              label: '签约人',
              width: 120,
            },
            {
              prop: 'contractValidFrom',
              label: '服务开始日期',
              width: 120,
            },
            {
              prop: 'contractValidUntil',
              label: '服务结束日期',
              width: 120,
            },
          ],
        };
      },
      // 园区物业租赁合同
      propertyLeaseContract() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: propertyLeaseApi.LEASE_CONTRACT_LIST_PAGE,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: '02',
          },
          searchColumns: [
            {
              name: '合同编号',
              prop: 'contractNo',
              type: 'input',
            },
            {
              name: '客户名称',
              prop: 'customerName',
              type: 'input',
            },
            {
              name: '纸质合同号',
              prop: 'paperContractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractCompanyName',
              label: '公司',
              width: 120,
            },
            {
              prop: 'contractDepartmentName',
              label: '部门',
              width: 120,
            },
            {
              prop: 'contractNo',
              label: '合同编号',
              width: 120,
            },
            {
              prop: 'customerName',
              label: '客户名称',
              width: 120,
            },
            {
              prop: 'contractName',
              label: '合同名称',
              width: 120,
            },

            {
              prop: 'contractCategory',
              label: '合同类别',
              width: 120,
              formatter: this.formatterPropertyLeaseContractType,
            },
            {
              prop: 'paperContractNo',
              label: '纸质合同编号',
              width: 120,
            },
            {
              prop: 'leaseDateFrom',
              label: '租赁开始日期',
              width: 120,
            },
            {
              prop: 'leaseDateUntil',
              label: '租赁结束日期',
            },

            {
              prop: 'contractStatus',
              label: '合同状态',
              width: 120,
              formatter: this.formatterPropertyLeaseContractStatus,
            },
            {
              prop: 'createPersonName',
              label: '创建人',
              width: 120,
            },
            {
              prop: 'gmtCreate',
              label: '创建时间',
              width: 120,
            },
            // {
            //   prop: 'signDate',
            //   label: '签约日期',
            //   width: 120,
            // },
            // {
            //   prop: 'signPlace',
            //   label: '签约地点',
            //   width: 120,
            // },
            // {
            //   prop: 'signPersonName',
            //   label: '签约人',
            //   width: 120,
            // },
          ],
        };
      },
      // 获取合同带有多个商品接口
      contractMultipleProduct() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: SALE_API.STATEMENT_CONTRACT_LIST_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('salePurchase.search.contractNo'),
              // width: 180,
            },
            {
              prop: 'contractDetailCategoryName',
              label: this.$t('salePurchase.search.contractCategory'),
              // width: 180,
            },
            {
              prop: 'contractCreateDate',
              label: this.$t('salePurchase.table.contractCreateDate'),
              // width: 190,
            },
          ],
        };
      },

      // 获取多是联运的接口  MULTRANSPORT_CONTRACT_LIST_API
      multransportContract() {
        return {
          width: '800',
          query: {
            contractCode: null,
            contractName: null,
            customerName: null,
          },
          API: SALE_API.MULTRANSPORT_CONTRACT_LIST_API,
          propName: 'contractCode', // 输入框展示内容
          propCode: 'contractCode',
          extraData: {},
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractCode',
              type: 'input',
            },
            {
              name: '合同名称',
              prop: 'contractName',
              type: 'input',
            },
            {
              name: '客户名称',
              prop: 'customerName',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractCode',
              label: '合同编号',
              // width: 180,
            },
            {
              prop: 'customerName',
              label: '客户名称',
              // width: 180,
            },
            {
              prop: 'contractName',
              label: '合同名称',
              // width: 180,
            },
            // {
            //   prop: 'contractSignDate',
            //   label: '签订日期',
            // },
            {
              prop: 'contractStatusName',
              label: '合同状态',
            },
          ],
        };
      },
      // 获取园区仓储的接口  PARKWAREHOUSE_CONTRACT_LIST_API
      parkWarehouseContract() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: SALE_API.PARKWAREHOUSE_CONTRACT_LIST_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {},
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同编号',
              // width: 180,
            },
            {
              prop: 'customerNameOne',
              label: '客户名称',
            },
            {
              prop: 'contractStatusName',
              label: '合同状态',
            },
            {
              prop: 'signingDate',
              label: '签约日期',
              // width: 180,
            },
          ],
        };
      },
      // 海宁合同
      contractHN() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: SALE_API.GET_LIST_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('salePurchase.search.contractNo'),
              width: 150,
            },
            {
              prop: 'contractDetailCategoryName',
              label: this.$t('salePurchase.search.contractCategory'),
              width: 150,
            },
            {
              prop: 'businessContractTotalAmount',
              label: '订单金额',
              width: 150,
            },
            {
              prop: 'contractCreateDate',
              label: this.$t('salePurchase.table.contractCreateDate'),
              width: 160,
            },
            {
              prop: 'signDate',
              label: '签单日期',
              width: 160,
            },
          ],
        };
      },
      // 海宁应收票据合同
      contractCollectHN() {
        return {
          width: '800',
          query: {
            contractNo: null,
          },
          API: SALE_API.GET_LIST_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('salePurchase.search.contractNo'),
              width: 150,
            },
            {
              prop: 'contractDetailCategoryName',
              label: this.$t('salePurchase.search.contractCategory'),
              width: 150,
            },
            {
              prop: 'customerName',
              label: '客户',
            },
            {
              prop: 'businessContractTotalAmount',
              label: '订单金额',
              width: 150,
            },
            {
              prop: 'receiveMarginAmount',
              label: '已认领保证金',
            },
            {
              prop: 'receiveGoodsAmount',
              label: '已认领货款',
            },
            {
              prop: 'registerAmount',
              label: '已认领总金额',
            },
            {
              prop: 'remainAmount',
              label: '可认领金额',
            },
            {
              prop: 'contractCreateDate',
              label: this.$t('salePurchase.table.contractCreateDate'),
              width: 160,
            },
            {
              prop: 'signDate',
              label: '签约日期',
              width: 160,
            },
          ],
        };
      },
      // 合同-带详情
      contractHasDetail() {
        return {
          query: {
            contractNo: null,
            groupByContractDetailNoFlag: '1',
          },
          API: SALE_API.GET_LIST_API,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同号',
              width: 120,
            },
            {
              prop: 'externalContractNo',
              label: '外部合同号',
              width: 120,
            },
            {
              prop: 'contractDetailNo',
              label: '合同行项目编号',
              width: 80,
            },
            {
              prop: 'productDesc',
              label: '商品描述',
              width: 200,
            },
            {
              prop: 'productQuantity',
              label: '数量',
              width: 100,
            },
            {
              prop: 'businessContractUnitPrice',
              label: '单价',
              width: 100,
            },
          ],
        };
      },
      // 多式联运订单号
      mulTransportOrder() {
        return {
          query: {
            orderCode: '',
          },
          API: MULTRANSPORT_API.ORDER_LIST,
          propName: 'orderCode', // 输入框展示内容
          propCode: 'orderCode',
          extraData: {},
          searchColumns: [
            {
              name: '订单编号',
              prop: 'orderCode',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'orderCode',
              label: '订单编号',
            },
            {
              prop: 'orderStatusName',
              label: '订单状态',
            },
            // {
            //   prop: 'productTypeName',
            //   label: '产品类型',
            // },
            // {
            //   prop: 'serviceTypeName',
            //   label: '服务类型',
            // },
          ],
        };
      },
      // 业务订单号
      businessOrder() {
        return {
          query: {
            orderNo: '',
          },
          API: SETTLE_API.LIST_BUSINESS_ORDER_BY_PAGE,
          propName: 'orderNo', // 输入框展示内容
          propCode: 'orderNo',
          extraData: {},
          searchColumns: [
            {
              name: this.$t('batchAdd.baseForm.orderNo'),
              prop: 'orderNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'orderNo',
              label: this.$t('batchAdd.baseForm.orderNo'),
            },
            {
              prop: 'contractNo',
              label: this.$t('businessOrder.list.contractNo'),
            },
            {
              prop: 'externalContractNo',
              label: this.$t('businessOrder.list.externalContractNo'),
            },
            {
              prop: 'productDesc',
              label: this.$t('businessOrder.list.productNo'),
            },
          ],
        };
      },
      // 业务订单号-去重
      businessOrderOther() {
        return {
          query: {
            orderNo: '',
          },
          API: SETTLE_API.LIST_BUSINESS_ORDER_OTHER_BY_PAGE,
          propName: 'orderNo', // 输入框展示内容
          propCode: 'orderNo',
          extraData: {},
          searchColumns: [
            {
              name: this.$t('batchAdd.baseForm.orderNo'),
              prop: 'orderNo',
              type: 'input',
            },
            {
              //供应链主体名称
              name: this.$t('batchAdd.baseForm.supplierName'),
              prop: 'supplierNoList',
              type: 'selectMultiple',
              options: this.supplierList,
            },
            {
              //业务部门
              name: this.$t('batchAdd.baseForm.businessDepartmentName'),
              prop: 'businessDepartmentCodeList',
              type: 'selectMultiple',
              options: this.departmentList,
            },
            {
              //开始时间
              prop: 'dateStart',
              name: this.$t('batchAdd.baseForm.dateStart'),
              type: 'startDaterangePicker',
            },
            {
              //结束时间
              prop: 'dateEnd',
              name: this.$t('batchAdd.baseForm.dateEnd'),
              type: 'endDaterangePicker',
            },
          ],
          columnList: [
            {
              //业务订单号
              prop: 'orderNo',
              label: this.$t('batchAdd.baseForm.orderNo'),
            },
            {
              //供应链主体
              prop: 'supplierName',
              label: this.$t('batchAdd.baseForm.supplierName'),
            },
            {
              //业务部门
              prop: 'businessDepartmentName',
              label: this.$t('businessOrder.list.businessDepartmentName'),
            },
            {
              //创建日期
              prop: 'gmtCreate',
              label: this.$t('businessOrder.list.gmtCreate'),
            },
          ],
        };
      },
      // 结算批次
      settle() {
        return {
          query: {
            settleNo: '',
          },
          API: SETTLE_API.LIST_ORDER_SETTLE_BY_PAGE,
          propName: 'settleNo', // 输入框展示内容
          propCode: 'settleNo',
          extraData: {},
          searchColumns: [
            {
              name: this.$t('batchList.column.settleNo'),
              prop: 'settleNo',
              type: 'input',
            },
            {
              name: this.$t('batchList.column.settleDesc'),
              prop: 'settleDesc',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'settleNo',
              label: this.$t('batchList.column.settleNo'),
            },
            {
              prop: 'settleDesc',
              label: this.$t('batchList.column.settleDesc'),
            },
          ],
        };
      },
      customs() {
        return {
          query: {
            productZhName: '',
            productCode: '',
          },
          API: GOODS_API.GET_CUSTOMS_LIST,
          propName: 'productCode', // 输入框展示内容
          propCode: 'productCode',
          searchColumns: [
            {
              name: this.$t('goods.form.customsId'),
              prop: 'productCode',
              type: 'input',
            },
            {
              name: this.$t('goods.form.customsName'),
              prop: 'productZhName',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'productZhName',
              label: this.$t('goods.form.productZhName'),
            },
            {
              prop: 'productCode',
              label: this.$t('goods.form.customsId'),
            },
          ],
        };
      },
      // 承兑合同号/外部合同号/合同行项目 -- 开证
      acceptContractDetail() {
        return {
          options: this.options,
          propName: this.propName, // 输入框展示内容
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('businessOrder.list.contractNo'),
              width: 120,
            },
            {
              prop: 'externalContractNo',
              label: this.$t('businessOrder.list.externalContractNo'),
              width: 120,
            },
            {
              prop: 'contractDetailNo',
              label: this.$t('businessOrder.list.contractDetailNo'),
              width: 120,
            },
            {
              prop: 'productDesc',
              label: this.$t('businessOrder.list.productNo'),
              width: 120,
            },
            {
              prop: 'issueAmount',
              label: '开证金额',
              width: 120,
            },
          ],
        };
      },
      // 承兑合同号/外部合同号 仅有合同号 -- 开证
      acceptContractDetailContract() {
        return {
          options: this.options,
          propName: this.propName, // 输入框展示内容
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('businessOrder.list.contractNo'),
            },
            {
              prop: 'externalContractNo',
              label: this.$t('businessOrder.list.externalContractNo'),
            },
          ],
        };
      },
      // 承兑合同号/外部合同号/客户  --收证
      acceptContractDetailRec() {
        return {
          options: this.options,
          propName: this.propName, // 输入框展示内容
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('businessOrder.list.contractNo'),
            },
            {
              prop: 'externalContractNo',
              label: this.$t('businessOrder.list.externalContractNo'),
            },
            {
              prop: 'customerName',
              label: this.$t('detailOrAcceptCredit.goodsTable.customerName'),
            },
          ],
        };
      },
      // 银行
      bank() {
        return {
          query: {
            bankCode: '',
          },
          API: BANK_API.GET_LIST_BANK,
          propName: 'bankName', // 输入框展示内容
          propCode: 'bankCode',
          expandAll: true,
          extraData: {
            bankStatus: '01',
          },
          searchColumns: [
            {
              name: '银行名称',
              prop: 'bankName',
              type: 'input',
            },
            {
              name: '分行',
              prop: 'branchName',
              type: 'input',
            },
            {
              name: '银行行号',
              prop: 'bankUnionNumber',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'bankCode',
              label: this.$t('bank.label.bankCode'),
            },
            {
              prop: 'bankName',
              label: '银行名称',
            },
            {
              prop: 'branchName',
              label: this.$t('bank.label.branch'),
            },
            {
              prop: 'bankUnionNumber',
              label: '银行行号',
            },
          ],
        };
      },
      bankCompany() {
        return {
          API: BANKACCOUNT_API.QUERY_BANKACCOUNT_PAGE,
          propName: 'branchName', // 输入框展示内容
          propCode: 'bankAccountNum',
          extraData: this.extraData,
          searchColumns: [
            {
              name: '开户行-分行',
              prop: 'branchName',
              type: 'input',
            },
            {
              name: '银行账号',
              prop: 'bankAccountNum',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'bankName',
              label: '银行名称',
            },
            {
              prop: 'branchName',
              label: this.$t('bank.label.branch'),
            },
            {
              prop: 'bankAccountNum',
              label: this.$t('bankAccountList.search.bankAccountNum'),
            },
            {
              prop: 'bankAccountName',
              label: this.$t('bankAccountList.search.bankAccountName'),
            },
          ],
        };
      },
      // 银行账号--bankAccountNum
      bankAccount() {
        return {
          query: {
            bankAccountNum: '',
          },
          API: BASE_API.QUERY_BANKACCOUNT_PAGE,
          propName: 'bankAccountNum', // 输入框展示内容
          propCode: 'bankAccountNum',
          extraData: {
            bankAccountStatus: '001',
          },
          searchColumns: [
            /* {
          prop: "bankName",
          label: this.$t("bankAccountList.search.bankName"),
          type: "input"
        }, */
            {
              name: this.$t('bankAccountList.search.bankAccountNum'),
              prop: 'bankAccountNum',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'bankName',
              label: this.$t('bankAccountList.table.bankName'),
            },
            {
              prop: 'branchName',
              label: this.$t('bankAccountList.table.branchName'),
            },
            {
              prop: 'bankAccountNum',
              label: this.$t('bankAccountList.search.bankAccountNum'),
            },
            {
              prop: 'bankAccountName',
              label: this.$t('bankAccountList.search.bankAccountName'),
            },
            {
              prop: 'bankAccountDesc',
              label: this.$t('bankAccountList.search.bankAccountDesc'),
            },
          ],
        };
      },

      // 银行账号--branchName
      bankAccountBranchName() {
        return {
          query: {
            branchName: '',
            bankAccountNum: '',
          },
          API: BASE_API.QUERY_BANKACCOUNT_PAGE,
          propName: 'branchName', // 输入框展示内容
          propCode: 'bankAccountNum',
          disableNoSearchData: true, // 禁止没有查询条件搜索
          extraData: {
            bankAccountStatus: '001',
          },
          searchColumns: [
            {
              prop: 'branchName',
              name: '开户行-分行',
              type: 'input',
            },
            {
              name: this.$t('bankAccountList.search.bankAccountNum'),
              prop: 'bankAccountNum',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'bankName',
              label: this.$t('bankAccountList.search.bankName'),
            },
            {
              prop: 'branchName',
              label: this.$t('bankAccountList.table.branchName'),
            },
            {
              prop: 'bankAccountNum',
              label: this.$t('bankAccountList.search.bankAccountNum'),
            },
            {
              prop: 'bankAccountName',
              label: this.$t('bankAccountList.search.bankAccountName'),
            },
            {
              prop: 'bankAccountDesc',
              label: this.$t('bankAccountList.search.bankAccountDesc'),
            },
          ],
        };
      },

      // 公司部门
      companyDept() {
        return {
          query: {
            belongCompanyName: '',
            belongCompanyCode: '',
            createDepartmentCode: '',
            createDepartmentName: '',
            currentStatus: 0,
          },
          API: BASE_API.QUERY_DEPT_BYPAGE,
          propName: 'createDepartmentName', // 输入框展示内容
          propCode: 'createDepartmentCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'belongCompanyName',
              name: this.$t('company.detail.companyName'),
              label: this.$t('company.placeholder.companyName'),
              type: 'input',
            },
            {
              prop: 'createDepartmentName',
              name: this.$t('company.detail.departmentName'),
              label: this.$t('company.placeholder.departmentName'),
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'belongCompanyCode',
              label: this.$t('company.detail.companyCode'),
            },
            {
              prop: 'belongCompanyName',
              label: this.$t('company.detail.companyName'),
            },
            {
              prop: 'createDepartmentCode',
              label: this.$t('company.detail.departmentCode'),
            },
            {
              prop: 'createDepartmentName',
              label: this.$t('company.detail.departmentName'),
            },
          ],
        };
      },
      // 成本中心
      sapCostCenter() {
        return {
          query: {
            costCenterCode: '',
            costCenterName: '',
          },
          API: BASE_API.GET_SAPCOSTCENTER,
          propName: 'createDepartmentName', // 输入框展示内容
          propCode: 'createDepartmentCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'costCenterCode',
              name: '成本中心代码',
              label: '成本中心代码',
              type: 'input',
            },
            {
              prop: 'costCenterName',
              name: '成本中心名称',
              label: '成本中心名称',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'costCenterCode',
              label: '成本中心代码',
            },
            {
              prop: 'costCenterName',
              label: '成本中心名称',
            },
          ],
        };
      },
      // 利润中心
      sapProfitCenter() {
        return {
          query: {
            profitCenterCode: '',
            profitCenterName: '',
          },
          API: BASE_API.GET_SAPPROFITCENTER,
          propName: 'profitCenterCode', // 输入框展示内容
          propCode: 'profitCenterCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'profitCenterCode',
              name: '利润中心代码',
              label: '利润中心代码',
              type: 'input',
            },
            {
              prop: 'profitCenterName',
              name: '利润中心名称',
              label: '利润中心名称',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'profitCenterCode',
              label: '利润中心代码',
            },
            {
              prop: 'profitCenterName',
              label: '利润中心名称',
            },
          ],
        };
      },
      // 信用证
      LC() {
        return {
          query: {
            clCode: '',
          },
          API: LC_API.QUERY_CREDITLETTER_PAGE,
          propName: 'clCode', // 输入框展示内容
          propCode: 'clCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'clCode',
              name: '信用证号',
              label: '信用证号',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'clCode',
              label: '信用证号',
            },
          ],
        };
      },

      //信用证承兑

      acceptanceLC() {
        return {
          query: {
            clCode: '',
          },
          API: LC_API.QUERY_LC_PAGE,
          propName: 'clCode', // 输入框展示内容
          propCode: 'clCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'clCode',
              name: this.$t('acceptanceDetail.goodsTable.clCode'),
              label: this.$t('acceptanceDetail.goodsTable.clCode'),
              type: 'input',
            },
            {
              name: this.$t('acceptanceDetail.goodsTable.sortNo'),
              label: this.$t('acceptanceDetail.goodsTable.sortNo'),
              prop: 'sortNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'clCode',
              label: this.$t('acceptanceDetail.goodsTable.clCode'),
            },
            {
              prop: 'sortNo',
              label: this.$t('acceptanceDetail.goodsTable.sortNo'),
            },
          ],
        };
      },

      //付款单查询
      payment() {
        return {
          query: {
            paymentNum: '',
          },
          API: PAYMENTED_API.LIST_PAYMENT_DELTAIL_BY_PAGE,
          propName: 'paymentNum', // 输入框展示内容
          propCode: 'paymentNum',
          extraData: {
            //invoiceCodeIsNull: 'Y'    //查询未关联发票的付款单
          },
          searchColumns: [
            {
              prop: 'paymentNum',
              name: this.$t('paymentList.table.paymentNum'),
              label: this.$t('paymentList.table.paymentNum'),
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'paymentNum',
              label: this.$t('paymentList.table.paymentNum'),
            },
            {
              prop: 'lineNumber',
              label: this.$t('paymentList.table.lineNumber'),
            },
          ],
        };
      },

      // 应付发票
      payable() {
        return {
          query: {
            paymentNum: '',
          },
          API: PAY_INVOICE_API.GET_DATA_API,
          propName: 'documentCode', // 输入框展示内容
          propCode: 'documentCode',
          extraData: {
            payableInvoiceStatusList: ['submitted', 'hold'],
          },
          searchColumns: [
            {
              prop: 'documentCode',
              name: this.$t('addInvoice.billInfo.documentCode'),
              label: this.$t('addInvoice.billInfo.documentCode'),
              type: 'input',
            },
            {
              name: this.$t('addInvoice.billInfo.invoiceUnitName'),
              label: this.$t('addInvoice.billInfo.invoiceUnitName'),
              prop: 'lineNumber',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'documentCode',
              label: this.$t('addInvoice.billInfo.documentCode'),
            },
            {
              prop: 'invoiceUnitName',
              label: this.$t('addInvoice.billInfo.invoiceUnitName'),
            },
          ],
        };
      },

      /*  以下为发票模块合并来未测试   start */
      // 销售合同
      saleContract() {
        return {
          query: {
            contractNo: '',
          },
          API: PAY_INVOICE_API.LIST_ORDER_BYPAGE,
          extraData: {
            // 合同类型
            contractCategory: 'sales',
          },
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          searchColumns: [
            {
              prop: 'contractNo',
              name: '合同号',
              type: 'input',
              placeholder: '请输入',
            },
            {
              prop: 'externalContractNo',
              name: '外部合同号',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同号',
              width: 200,
            },
            {
              prop: 'externalContractNo',
              label: '外部合同号',
              width: 200,
            },
            /* {
        prop: "relatedContractType",
        label: '合同类型',
        width: 200
      }, */
            {
              prop: 'contractStatusName',
              label: '合同状态',
            },
          ],
        };
      },

      // 销售提单号
      salesLading() {
        return {
          API: PAY_INVOICE_API.LIST_STORAGE_LAGE_PAGE,
          propName: 'ladingNo', // 输入框展示内容
          propCode: 'ladingNo',
          searchColumns: [
            {
              prop: 'ladingNo',
              name: '提单号',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'ladingNo',
              label: '提单号',
              width: 200,
            },
            {
              prop: 'gmtCreate',
              label: '提单日期',
              width: 200,
            },
          ],
        };
      },
      // 销售提单（包括行信息）
      salesLadingDetail() {
        return {
          API: PAY_INVOICE_API.LIST_STORAGE_LAGE_PAGE,
          propName: 'ladingNo', // 输入框展示内容
          propCode: 'ladingNo',
          query: { isStorageLadeDetail: '1' },
          searchColumns: [
            {
              prop: 'ladingNo',
              name: '提单号',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'ladingNo',
              label: '提单号',
              width: 200,
            },
            {
              prop: 'ladingDetailNo',
              label: '提单行号',
              width: 200,
            },
            {
              prop: 'productNo',
              label: '商品编码',
              width: 200,
            },
            {
              prop: 'productDesc',
              label: '商品描述',
              width: 200,
            },
            {
              prop: 'ladingQuantity',
              label: '提单数量',
              width: 200,
            },
            {
              prop: 'gmtCreate',
              label: '提单日期',
              width: 200,
            },
          ],
        };
      },

      // 行项目号
      contractDetailNo() {
        return {
          API: PAYMENT_API.LIST_ORDER_DETAIL_BY_PAGE,
          propName: this.searchTypeClone?.propName || 'contractDetailNo', // 输入框展示内容
          propCode: this.searchTypeClone?.propCode || 'contractDetailNo',
          searchColumns: [
            {
              prop: 'contractNo',
              name: '合同号',
              type: 'input',
              width: 200,
              placeholder: '请输入',
            },
            {
              prop: 'contractDetailNo',
              name: '合同行项目编号',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: '合同号',
              width: 120,
            },
            {
              prop: 'externalContractNo',
              label: '外部合同号',
              width: 120,
            },
            {
              prop: 'contractDetailNo',
              label: '合同行项目编号',
              width: 80,
            },
            {
              prop: 'productDesc',
              label: '商品描述',
              width: 200,
            },
            {
              prop: 'productQuantity',
              label: '数量',
              width: 100,
            },
            {
              prop: 'businessContractUnitPrice',
              label: '单价',
              width: 100,
            },
          ],
        };
      },
      //发货指令
      shippingInstruction() {
        return {
          query: { purchaseContractNo: '', externalContractNo: '', instructionNo: '' },
          API: BATCH_API.GET_DATA_API,
          propName: 'instructionNo', // 输入框展示内容
          propCode: 'instructionNo',
          searchColumns: [
            {
              name: '采购合同号',
              prop: 'purchaseContractNo',
              type: 'input',
            },
            {
              name: '外部合同号',
              prop: 'externalContractNo',
              type: 'input',
            },
            {
              name: this.$t('supplierDeliveryOrder.search.instructionNo'),
              prop: 'instructionNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'instructionNo',
              label: this.$t('supplierDeliveryOrder.search.instructionNo'),
            },
            {
              prop: 'partnerName',
              label: this.$t('supplierDeliveryOrder.search.partnerNo'),
            },
            {
              prop: 'instructionDetailNo',
              label: '行项目号',
            },
            {
              prop: 'instructionNumber',
              label: '发货指令数量',
            },
            {
              prop: 'contractUnitPrice',
              label: '合同单价',
            },
            {
              prop: 'purchaseContractNo',
              label: '采购合同号',
            },
            {
              prop: 'externalContractNo',
              label: '外部合同号',
            },

            /* {
          prop: "companyName",
          label: this.$t("supplierDeliveryOrder.search.companyName")
        },
        {
          prop: "instructionDepartmentName",
          label: this.$t("supplierDeliveryOrder.search.departmentName")
        }, */
          ],
        };
      },
      // 应收应付票据
      bill() {
        return {
          query: {
            billCode: null,
            billSerialNumber: null,
            expiringDateBegin: null,
            expiringDateEnd: null,
            billAmountMin: null,
            billAmountMax: null,
          },
          API: BILL_API.QUERY_FUNDBILL_PAGE,
          propName: 'billCode', // 输入框展示内容
          propCode: 'billCode',
          extraData: {},
          searchColumns: [
            {
              name: this.$t('billList.column.billCode'),
              prop: 'billCode',
              type: 'input',
            },
            {
              //金额开始结束
              type: 'input',
              prop: 'billAmountMin',
              precision: 2, //精度，就是保留几位小数,默认两位
              max: 99999999999999.99,
              name: '票据金额从',
            },
            {
              //金额开始结束
              type: 'input',
              prop: 'billAmountMax',
              precision: 2, //精度，就是保留几位小数,默认两位
              max: 99999999999999.99,
              name: '票据金额到',
            },
            {
              // 开票日期从
              name: '开票日期从',
              prop: 'expiringDateBegin',
              type: 'startDaterangePicker',
            },
            {
              // 到期日到
              name: '到期日到',
              prop: 'expiringDateEnd',
              type: 'endDaterangePicker',
            },
          ],
          columnList: [
            {
              prop: 'billSerialNumber',
              label: this.$t('billList.column.billSerialNumber'),
              width: 150,
            },
            {
              prop: 'billCode',
              label: this.$t('billList.column.billCode'),
              width: 120,
            },
            {
              prop: 'expiringDate',
              label: '到期日',
              width: 100,
            },
            {
              prop: 'billAmount',
              label: '票据金额',
              width: 120,
            },
          ],
        };
      },
      // 科目
      account() {
        return {
          query: {
            accountCode: null,
          },
          API: BASE_API.GET_ACCOUNTDETAIL_PAGE,
          propName: 'accountDesc', // 输入框展示内容
          propCode: 'accountCode',
          extraData: {
            isAvailable: '1',
          },
          searchColumns: [
            {
              prop: 'accountCode',
              name: '科目编码',
              type: 'input',
              placeholder: '请输入科目编码',
            },

            {
              prop: 'accountDesc',
              name: '科目说明',
              type: 'input',
              placeholder: '请输入科目说明',
            },
          ],
          columnList: [
            {
              prop: 'accountCode',
              label: '科目编码',
            },
            {
              prop: 'accountDesc',
              label: '科目说明',
            },
          ],
        };
      },
      // 日历
      calendar() {
        return {
          query: {
            calendarCode: null,
          },
          type: 'get',
          API: CALENDAR_API.LIST_ACCOUNT_CALEDAR_DETAILS,
          propName: 'calendarCode', // 输入框展示内容
          propCode: 'calendarCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'calendarCode',
              name: '日历代码',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'calendarCode',
              label: '日历代码',
            },
            {
              prop: 'periodName',
              label: '期间名称',
            },
          ],
        };
      },
      // 生产中心账期
      pdPeriod() {
        return {
          query: {
            projectCode: null,
            periodName: null,
          },
          type: 'post',
          API: PDPERIOD_API.QUERY_PDPERIOD_PAGE,
          propName: 'periodName', // 输入框展示内容
          propCode: 'periodCode',
          extraData: {
            //periodStatus: 'opened'
          },
          searchColumns: [
            {
              prop: 'periodName',
              name: this.$t('pdPeriod.column.periodName'),
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'projectName',
              label: this.$t('pdPeriod.column.projectName'),
            },
            {
              prop: 'periodName',
              label: this.$t('pdPeriod.column.periodName'),
            },
            {
              prop: 'startDate',
              label: this.$t('pdPeriod.column.startDate'),
            },
            {
              prop: 'endDate',
              label: this.$t('pdPeriod.column.endDate'),
            },
          ],
        };
      },
      // 现金流量代码
      cashflow() {
        return {
          query: {
            cashflowCodeLike: null,
          },
          API: BASE_API.GET_SAPCASHFLOW_PAGE,
          propName: 'cashflowName', // 输入框展示内容
          propCode: 'cashflowCode',
          extraData: {},
          searchColumns: [
            {
              prop: 'cashflowCodeLike',
              name: '现金流量代码',
              type: 'input',
              placeholder: '请输入',
            },
          ],
          columnList: [
            {
              prop: 'cashflowCode',
              label: '现金流量代码',
            },
            {
              prop: 'cashflowName',
              label: '现金流量名称',
            },
          ],
        };
      },

      /*  以下为发票模块合并来未测试   end */

      // 生产中心-商品编码--展示 原料/产品编码和原料/产品名称字段
      produceProduct() {
        return {
          query: {
            productName: '',
          },
          API: PRODUCE_PRODUCT_API.LIST_PRODUCT_CODE,
          propCode: 'productCode',
          propName: 'productName', // 输入框展示内容
          extraData: {},
          searchColumns: [
            {
              name: this.$t('costConfirmationList.search.productName'),
              prop: 'productName',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'productCode',
              label: this.$t('costConfirmationList.search.productCode'),
            },
            {
              prop: 'productName',
              label: this.$t('costConfirmationList.search.productName'),
            },
          ],
        };
      },
      // 生产中心-配方
      produceFurmula() {
        return {
          query: {
            formulaNo: '',
          },
          API: PRODUCE_FORMULA.QUERY_ALL_FORMULA,
          propCode: 'formulaNo',
          propName: 'formulaNo', // 输入框展示内容
          extraData: {},
          searchColumns: [
            {
              name: this.$t('prescriptionList.search.formulaNo'),
              prop: 'formulaNo',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'formulaNo',
              label: this.$t('prescriptionList.search.formulaNo'),
            },
            /* {
          prop: "statusFlag",
          label: this.$t("prescriptionList.search.statusFlag"),
        },
        {
          prop: "formulaUsage",
          label: this.$t("prescriptionList.search.formulaUsage")
        }, */
          ],
        };
      },
      // 期货策略-策略详情
      ptcombiDetail() {
        return {
          query: {
            ptcombiNo: '',
          },
          API: FUTURES_API.LIST_PROCOMBI_BY_PAGE,
          propCode: 'ptcombiNo',
          propName: 'combiName', // 输入框展示内容
          extraData: {},
          searchColumns: [
            {
              name: this.$t('futuresStrategy.futuresStrategyList.search.ptcombiNo'),
              prop: 'ptcombiNo',
              type: 'input',
              maxlength: '30',
            },
          ],
          columnList: [
            {
              prop: 'ptcombiNo',
              label: this.$t('futuresStrategy.futuresStrategyList.search.ptcombiNo'),
            },
            {
              prop: 'combiName',
              label: this.$t('futuresStrategy.futuresStrategyList.search.combiName'),
            },
          ],
        };
      },
      // 海宁订单
      hnOrder() {
        return {
          query: {
            contractNo: '',
            dataGroup: this.$globalVar.subserver.dataGroup,
          },
          API: AGENCYCONTRACT_API.LIST_TRADEORDERANDORDER,
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {},
          searchColumns: [
            {
              name: '订单编号',
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'signDate',
              label: '合同日期',
            },
            {
              prop: 'contractNo',
              label: '订单编号',
            },
            {
              prop: 'contractCategory',
              label: '订单类型',
            },
          ],
        };
      },
      // 电表
      meter() {
        return {
          API: '/property/electricMeter/listByConditions',
          propName: 'meterNo', // 输入框展示内容
          propCode: 'meterNo',
          query: {
            meterNo: null,
            effectiveStatus: '',
          },
          extraData: {},
          searchColumns: [
            {
              prop: 'meterNo',
              name: '电表编号',
              type: 'input',
              placeholder: '请输入电表编号',
            },
            {
              prop: 'meterType',
              name: '电表类型',
              type: 'select',
              options: [
                { value: '', label: '全部' },
                { value: '1', label: '变压器总表' },
                { value: '2', label: '线路总表' },
                { value: '3', label: '区域总表' },
                { value: '4', label: '区域总表' },
              ],
              placeholder: '请输入电表类型',
            },
          ],
          columnList: [
            { prop: 'meterNo', label: '电表编号' },
            { prop: 'meterType', label: '电表类型' },
            { prop: 'transformer', label: '变压器' },
            { prop: 'line', label: '线路' },
            { prop: 'areaName', label: '区域名称' },
            { prop: 'effectiveStatus', label: '生效状态' },
          ],
        };
      },

      //项目table
      project() {
        return {
          API: '/sales/project/listPage',
          propName: 'projectName', // 输入框展示内容
          propCode: 'projectCode',
          query: {
            projectName: null,
          },
          extraData: {},
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            { prop: 'projectName', label: '项目名称', width: 180 },
            { prop: 'projectCode', label: '项目编码', width: 120 },
            { prop: 'companyNames', label: '公司名称' },
            { prop: 'companyCodes', label: '公司代码', width: 120 },
            { prop: 'creditLine', label: '项目授信额度（元）', width: 120 },
          ],
        };
      },
      settlementParkWarehouseContract() {
        return {
          API: '/sales/contractInfo/listContractByPage',
          propName: 'contractNo',
          propCode: 'contractNo',
          query: {
            contractNo: null,
            customerName: null,
            paperContractNo: null,
          },
          extraData: {
            parkCompanyCodeList: [this.userInfo.companyCode],
            businessDepartmentList: [this.userInfo.departmentCode],
          },
          searchColumns: [
            {
              prop: 'contractNo',
              name: '合同编号',
              type: 'input',
              placeholder: '请输入合同编号',
            },
            {
              prop: 'customerName',
              name: '客户名称',
              type: 'input',
              placeholder: '请输入客户名称',
            },
            {
              prop: 'paperContractNo',
              name: '纸质合同号',
              type: 'input',
              placeholder: '请输入纸质合同号',
            },
          ],
          columnList: [
            {
              prop: 'parkCompany',
              label: '公司',
            },
            {
              prop: 'businessDepartment',
              label: '部门',
            },
            {
              prop: 'projectName',
              label: '项目名称',
            },
            {
              prop: 'projectCode',
              label: '项目编号',
            },
            {
              prop: 'contractNo',
              label: '合同编号',
            },
            {
              prop: 'resultCustomer',
              label: '客户名称',
            },
            {
              prop: 'paperContractNo',
              label: '纸质合同号',
            },
            {
              prop: 'contractStatusName',
              label: '合同状态',
            },
            {
              prop: 'dateStart',
              label: '开始日期',
            },
            {
              prop: 'dateEnd',
              label: '结束日期',
            },
            {
              prop: 'goodsTypeName',
              label: '货物类型',
            },
          ],
        };
      },
      // 已生效项目(仓储合同新增专用)
      warehouseContractProject() {
        return {
          API: warehouseContractApi.LIST_CONTRACT,
          propName: 'projectCode', // 输入框展示内容
          propCode: 'projectCode',
          query: {
            projectName: null,
            projectCode: null,
          },
          extraData: {
            projectStatus: 'ZT04',
            serviceTypeCode: 'CC',
            bidTitle: this.userInfo.companyName,
            applyDepartmentNo: this.userInfo.departmentCode,
          },
          searchColumns: [
            {
              prop: 'projectCode',
              name: '项目编号',
              type: 'input',
              placeholder: '请输入项目编号',
            },
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            {
              prop: 'projectCode',
              label: '项目编号',
            },
            {
              prop: 'projectName',
              label: '项目名称',
            },
            {
              prop: 'applyDepartmentName',
              label: '申请部门',
            },
            {
              prop: 'applyDate',
              label: '立项申请日期',
            },
          ],
        };
      },
      // 已生效项目(仓储合同列表专用)
      warehouseContractListProject() {
        return {
          API: warehouseContractApi.LIST_CONTRACT,
          propName: 'projectName', // 输入框展示内容
          propCode: 'projectName',
          query: {
            projectName: null,
            projectCode: null,
          },
          extraData: {
            projectStatus: 'ZT05',
            serviceTypeCode: 'CC',
            bidTitle: this.userInfo.companyName,
            applyDepartmentNo: this.userInfo.departmentCode,
          },
          searchColumns: [
            {
              prop: 'projectCode',
              name: '项目编号',
              type: 'input',
              placeholder: '请输入项目编号',
            },
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            {
              prop: 'projectCode',
              label: '项目编号',
            },
            {
              prop: 'projectName',
              label: '项目名称',
            },
            {
              prop: 'applyDepartmentName',
              label: '申请部门',
            },
            {
              prop: 'applyDate',
              label: '立项申请日期',
            },
          ],
        };
      },
      // 监管合同立项
      warehouseProject() {
        return {
          API: warehouseProjectApi.LIST_PROJECT,
          propName: 'projectName', // 输入框展示内容
          propCode: 'projectCode',
          query: {
            projectName: null,
          },
          extraData: {},
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            {
              prop: 'applyDate',
              label: '立项申请日期',
              width: '140',
            },
            {
              prop: 'projectCode',
              label: '项目编号',
              width: '140',
            },
            {
              prop: 'projectName',
              label: '项目名称',
              width: '140',
            },
            {
              prop: 'projectStatusName',
              label: '项目状态',
              width: '140',
            },
            {
              prop: 'applyDepartmentName',
              label: '申请部门',
              width: '140',
            },

            {
              prop: 'bidTitle',
              label: '投标抬头',
              width: '140',
            },
            {
              prop: 'projectResponsiblePerson',
              label: '项目负责人',
              width: '140',
            },
            {
              prop: 'bidderName',
              label: '投标人员',
              width: '140',
            },
            {
              prop: 'projectSourceTypeName',
              label: '项目来源',
              width: '140',
            },
            {
              prop: 'bidTotalAmount',
              label: '项目金额',
              width: '140',
            },
            {
              prop: 'bidOpeningDate',
              label: '开标日期',
              width: '140',
            },
            {
              prop: 'bidClosingDate',
              label: '截标日期',
              width: '140',
            },
            {
              prop: 'serviceTypeName',
              label: '服务类型',
              width: '140',
            },
            {
              prop: 'projectStartDate',
              label: '项目开始日期',
              width: '140',
            },
            {
              prop: 'projectEndDate',
              label: '项目结束日期',
              width: '140',
            },
          ],
        };
      },
      //搜索多式联运项目
      projectIntermodality() {
        return {
          API: '/sales/mtoProject/page',
          propName: 'projectCode', // 输入框展示内容
          propCode: 'projectCode',
          query: {
            projectCode: null,
          },
          extraData: {
            projectStatus: ['xmzt03', 'xmzt05'],
          },
          searchColumns: [
            {
              name: '项目编号',
              prop: 'projectCode',
              type: 'input',
              placeholder: '请输入项目编号',
            },
          ],
          columnList: [
            {
              prop: 'projectCode',
              label: '项目编号',
              width: 100,
            },
            {
              prop: 'projectName',
              label: '项目名称',
              width: 140,
            },
            {
              prop: 'bidTitle',
              label: '投标抬头',
              width: 100,
            },
            {
              prop: 'serviceTypeName',
              label: '服务类型',
              width: 100,
            },
            {
              prop: 'projectStartDate',
              label: '项目开始日期',
              width: 100,
            },
            {
              prop: 'projectEndDate',
              label: '项目结束日期',
              width: 100,
            },
            // {
            //   prop: 'projectStatus',
            //   label: '项目状态',
            //   width: 100,
            //   dictType: 'INTERMODALITY-PROJECT-STATUS',
            // },
          ],
        };
      },
      //项目立项table
      projectInitiation() {
        return {
          API: '/sales/projectInitiation/page',
          propName: 'projectInitiationNo', // 输入框展示内容
          propCode: 'projectInitiationNo',
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            { prop: 'projectName', label: '项目名称', width: 180 },
            { prop: 'projectInitiationNo', label: '项目编码', width: 120 },
            { prop: 'applyCompanyName', label: '公司名称' },
            { prop: 'applyCompanyNo', label: '公司代码', width: 120 },
            { prop: 'customerNo', label: '客户编码', width: 120 },
            { prop: 'customerName', label: '客户名称', width: 120 },
            { prop: 'projectUsageQuota', label: '项目使用额度(元)', width: 120 },
            { prop: 'projectReceivableQuota', label: '项目应收账款额度(元)', width: 120 },
          ],
        };
      },
      // 项目立项2
      projectList() {
        return {
          API: ProjectApi.PROJECT_List,
          propName: 'projectName', // 输入框展示内容
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: [
            {
              prop: 'projectInitiationNo',
              label: '立项编号',
              visible: true,
            },
            {
              prop: 'businessType',
              label: '业务类型',
              visible: true,
              dictType: 'PROJECT_INITIATION_BUSINESS_TYPE',
            },
            {
              prop: 'projectName',
              label: '项目名称',
              visible: true,
            },
            {
              prop: 'projectAbbreviation',
              label: '项目简称',
              visible: true,
            },
            {
              prop: 'customerName',
              label: '客户名称',
              visible: true,
            },
          ],
        };
      },
      // 专门给采购使用的
      // projectList1() {
      //   return {
      //     API: ProjectApi.PROJECT_LIST1,
      //     propName: 'projectName', // 输入框展示内容
      //     query: {
      //       projectName: null,
      //     },
      //     searchColumns: [
      //       {
      //         prop: 'projectName',
      //         name: '项目名称',
      //         type: 'input',
      //         placeholder: '请输入项目名称',
      //       },
      //       {
      //         prop: 'projectInitiationNo',
      //         name: '立项编号',
      //         type: 'input',
      //         placeholder: '请输入立项编号',
      //       },
      //     ],
      //     columnList: [
      //       {
      //         prop: 'projectInitiationNo',
      //         label: '立项编号',
      //         visible: true,
      //       },
      //       {
      //         prop: 'businessTypeName',
      //         label: '业务类型',
      //         visible: true,
      //       },
      //       {
      //         prop: 'projectName',
      //         label: '项目名称',
      //         visible: true,
      //       },
      //       {
      //         prop: 'customerName',
      //         label: '客户名称',
      //         visible: true,
      //       },
      //     ],
      //   };
      // },
      // 物贸应付结算-项目简称
      projectList1() {
        return {
          API: '/sales/goodsTradeProject/page',
          propName: 'projectName', // 输入框展示内容
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectNameLike',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
            {
              prop: 'projectInitiationNoLike',
              name: '立项编号',
              type: 'input',
              placeholder: '请输入立项编号',
            },
          ],
          columnList: [
            {
              prop: 'projectInitiationNo',
              label: '立项编号',
              visible: true,
            },
            {
              prop: 'businessTypeName',
              label: '业务类型',
              visible: true,
            },
            {
              prop: 'projectName',
              label: '项目名称',
              visible: true,
            },
            // {
            //   prop: 'projectAbbreviation',
            //   label: '项目简称',
            //   visible: true,
            // },
            {
              prop: 'customerName',
              label: '客户名称',
              visible: true,
            },
          ],
        };
      },
      // 项目额度用的项目列表
      limitProjectListWumao() {
        return {
          API: '/sales/goodsTradeProject/purchaseContractPage',
          propName: 'projectName', // 输入框展示内容
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
            {
              prop: 'projectInitiationNo',
              name: '立项编号',
              type: 'input',
              placeholder: '请输入立项编号',
            },
          ],
          columnList: [
            {
              prop: 'projectName',
              label: '项目名称',
            },
            {
              prop: 'projectInitiationNo',
              label: '项目编号',
            },
            { prop: 'applyCompanyName', label: '公司名称' },
            { prop: 'applyCompanyNo', label: '公司代码', width: 120 },
            { prop: 'projectUsageQuota', label: '项目授信额度（元）', width: 120 },
          ],
        };
      },
      // 物贸的项目列表
      projectListWumao() {
        return {
          API: '/sales/goodsTradeProject/purchaseContractPage',
          propName: 'projectName', // 输入框展示内容
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
            {
              prop: 'projectInitiationNo',
              name: '立项编号',
              type: 'input',
              placeholder: '请输入立项编号',
            },
          ],
          columnList: [
            {
              prop: 'projectInitiationNo',
              label: '立项编号',
              visible: true,
            },
            {
              prop: 'businessTypeName',
              label: '业务类型',
              visible: true,
            },
            {
              prop: 'projectName',
              label: '项目名称',
              visible: true,
            },
            // {
            //   prop: 'projectAbbreviation',
            //   label: '项目简称',
            //   visible: true,
            // },
            {
              prop: 'customerName',
              label: '客户名称',
              visible: true,
            },
          ],
        };
      },
      // 物贸的项目列表
      projectListWumaoByPage() {
        return {
          API: '/sales/goodsTradeProject/page',
          propName: 'projectName', // 输入框展示内容
          query: {
            projectName: null,
          },
          searchColumns: [
            {
              prop: 'projectName',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
            {
              prop: 'projectInitiationNo',
              name: '立项编号',
              type: 'input',
              placeholder: '请输入立项编号',
            },
          ],
          columnList: [
            {
              prop: 'projectInitiationNo',
              label: '立项编号',
              visible: true,
            },
            {
              prop: 'businessTypeName',
              label: '业务类型',
              visible: true,
            },
            {
              prop: 'projectName',
              label: '项目名称',
              visible: true,
            },
            // {
            //   prop: 'projectAbbreviation',
            //   label: '项目简称',
            //   visible: true,
            // },
            {
              prop: 'customerName',
              label: '客户名称',
              visible: true,
            },
          ],
        };
      },

      // 物贸的项目列表
      commonProject() {
        let businessCategory = this.extraData.businessCategory;
        let statusList = [];
        let columnList = [
          {
            prop: 'projectName',
            label: '项目名称',
            visible: true,
          },
          {
            prop: 'projectNo',
            label: '项目编号',
            visible: true,
          },

          {
            prop: 'projectCompanyName',
            label: '公司名称',
            visible: true,
          },
          {
            prop: 'projectCompanyNo',
            label: '公司编码',
            visible: true,
          },
          {
            prop: 'customerName',
            label: '客户名称',
            visible: true,
          },
          {
            prop: 'customerNo',
            label: '客户编码',
            visible: true,
          },
          { prop: 'projectUsageQuota', label: '项目使用额度(元)', width: 120 },
          { prop: 'projectReceivableQuota', label: '项目应收账款额度(元)', width: 120 },
          // {
          //   prop: 'businessTypeName',
          //   label: '业务类型',
          //   visible: true,
          // },
          // {
          //   prop: 'projectAbbreviation',
          //   label: '项目简称',
          //   visible: true,
          // },
        ];
        switch (businessCategory) {
          case '01':
            statusList = ['PIS04', 'PIS05', 'PIS07', 'PIS08'];
            //成矿贸易
            break;
          case '02':
            //物贸贸易
            statusList = ['PIS04', 'PIS05', 'PIS07', 'PIS08'];
            break;
          case '03':
            //多联
            // statusList.push('xmzt03');
            columnList = [
              {
                prop: 'projectName',
                label: '项目名称',
                visible: true,
              },
              {
                prop: 'projectNo',
                label: '项目编号',
                visible: true,
              },
              {
                prop: 'platformCompanyCode',
                label: '平台公司代码',
                visible: true,
              },
              {
                prop: 'platformCompanyName',
                label: '平台公司',
                visible: true,
              },
              {
                prop: 'projectStatus',
                label: '项目状态',
                visible: true,
                formatter: this.formatterIntermodalityProjectStatus,
              },
            ];
            break;
          case '04':
            //仓储合同
            statusList.push('zt04');
            columnList = [
              {
                prop: 'projectName',
                label: '项目名称',
                visible: true,
              },
              {
                prop: 'projectNo',
                label: '项目编号',
                visible: true,
              },
              {
                prop: 'projectCompanyName',
                label: '公司',
                visible: true,
              },
              {
                prop: 'projectDepartmentName',
                label: '部门名称',
                visible: true,
              },
            ];
            break;
          case '05':
            break;
          case '06':
            //监管合同
            break;
        }

        return {
          API: '/sales/common/project/page',
          propName: 'projectName', // 输入框展示内容
          propCode: 'projectCode',
          extraData: {
            statusList: statusList,
            businessCategory: businessCategory,
          },
          query: {
            projectNameLike: null,
          },
          searchColumns: [
            {
              prop: 'projectNameLike',
              name: '项目名称',
              type: 'input',
              placeholder: '请输入项目名称',
            },
          ],
          columnList: columnList,
        };
      },
      // 账户
      personAccount() {
        return {
          API: '/maindata/userAccount/listUserAccount',
          propName: 'userName', // 输入框展示内容
          propCode: 'userName',
          query: {
            userName: null,
          },
          searchColumns: [
            {
              prop: 'userName',
              name: '用户姓名',
              type: 'input',
              placeholder: '请输入用户姓名',
            },
            {
              prop: 'userAcct',
              name: '用户账号',
              type: 'input',
              placeholder: '请输入用户账号',
            },
          ],
          columnList: [
            { prop: 'userAccount', label: '用户账号', width: 180 },
            { prop: 'userName', label: '用户姓名', width: 120 },
            { prop: 'sex', label: '性别' },
            { prop: 'phone', label: '手机号', width: 120 },
            { prop: 'email', label: '邮箱', width: 120 },
          ],
        };
      },
      // 审批账户配置
      personAccountApprover() {
        return {
          API: '/maindata/userAccount/listUserAccountForApprover',
          propName: 'userName', // 输入框展示内容
          propCode: 'userName',
          query: {
            userName: null,
          },
          searchColumns: [
            {
              prop: 'userName',
              name: '用户姓名',
              type: 'input',
              placeholder: '请输入用户姓名',
            },
            {
              prop: 'userAcct',
              name: '用户账号',
              type: 'input',
              placeholder: '请输入用户账号',
            },
          ],
          columnList: [
            { prop: 'userAccount', label: '用户账号', width: 180 },
            { prop: 'userName', label: '用户姓名', width: 120 },
            { prop: 'sex', label: '性别' },
            { prop: 'phone', label: '手机号', width: 120 },
            { prop: 'email', label: '邮箱', width: 120 },
          ],
        };
      },
      // 账户
      role() {
        return {
          API: '/maindata/role/listRolesInfo',
          propName: 'roleName', // 输入框展示内容
          propCode: 'roleCode',
          query: {
            roleName: null,
          },
          searchColumns: [
            {
              prop: 'roleName',
              name: '角色名称',
              type: 'input',
              placeholder: '请输入角色名称',
            },
          ],
          columnList: [
            { prop: 'roleName', label: '角色名称' },
            { prop: 'applicationName', label: '应用名称' },
            { prop: 'remark', label: '备注' },
          ],
        };
      },
      // 仓库的主数据
      storageTableDialog() {
        return {
          width: '800',
          query: {
            storageName: '',
          },
          API: STORE_API.GET_STORAGE_DROP_DOWN,
          propCode: 'id',
          propName: 'storageName', // 输入框展示内容
          searchColumns: [
            {
              name: '仓库名称',
              prop: 'storageName',
              type: 'input',
              maxlength: '30',
              isNeedMultipleValue: this.isNeedMultipleValue,
            },
          ],
          columnList: [
            {
              prop: 'storageCode',
              label: '编码',
            },
            {
              prop: 'storageName',
              label: '名称',
            },
            {
              prop: 'storageCompanyName',
              label: '所属组织',
            },
            {
              prop: 'storageCreatePersonName',
              label: '创建人',
            },
            {
              prop: 'storageCreateTime',
              label: '创建时间',
              width: 100,
            },
          ],
        };
      },
      commonPayableSettlement() {
        return {
          API: PAYMENTED_API.PAYABLE_SETTLEMENT_PAGE,
          propName: 'payableSettlementNo', // 输入框展示内容
          propCode: 'payableSettlementNo',
          query: {
            payableSettlementNoLike: null,
          },
          extraData: {
            settlementStatus: '04',
          },
          searchColumns: [
            {
              prop: 'payableSettlementNoLike',
              name: '结算单编号',
              type: 'input',
              placeholder: '请输入结算单编号',
            },
          ],
          columnList: [
            {
              prop: 'payableSettlementNo',
              label: '结算单编号',
            },
            {
              prop: 'settlementCompanyName',
              label: '公司',
            },
            {
              prop: 'settlementDepartmentName',
              label: '部门',
            },
            {
              prop: 'originalTotalAmount',
              label: '结算金额',
            },
            {
              prop: 'paidAmount',
              label: '已付款金额',
            },
            {
              prop: 'currencyName',
              label: '币种名称',
            },
            {
              prop: 'contractNo',
              label: '合同编号',
            },
            {
              prop: 'supplierName',
              label: '供应商名称',
            },
            {
              prop: 'projectInitiationNo',
              label: '项目编码',
            },
            {
              prop: 'remark',
              label: '备注',
            },
          ],
        };
      },
      // 应付结算单
      payableSettlement() {
        return {
          API: PAYMENTED_API.PAYABLE_SETTLEMENT_PAGE,
          propName: 'payableSettlementNo', // 输入框展示内容
          propCode: 'payableSettlementNo',
          query: {
            payableSettlementNoLike: null,
          },
          extraData: {
            settlementStatus: '04',
          },
          searchColumns: [
            {
              prop: 'payableSettlementNoLike',
              name: '结算单编号',
              type: 'input',
              placeholder: '请输入结算单编号',
            },
            {
              prop: 'settlementBusinessTypeStatus',
              name: '贸易类型',
              type: 'select',
              options: this.dictListMap?.businessCategory,
            },
          ],
          columnList: [
            {
              prop: 'payableSettlementNo',
              label: '结算单编号',
            },
            {
              prop: 'settlementCompanyName',
              label: '公司',
            },
            {
              prop: 'settlementDepartmentName',
              label: '部门',
            },
            {
              prop: 'originalTotalAmount',
              label: '结算金额',
            },
            {
              prop: 'paidAmount',
              label: '已付款金额',
            },
            {
              prop: 'currencyName',
              label: '币种名称',
            },
            {
              prop: 'contractNo',
              label: '合同编号',
            },
            {
              prop: 'supplierName',
              label: '供应商名称',
            },
            {
              prop: 'projectInitiationNo',
              label: '项目编码',
            },
            {
              prop: 'remark',
              label: '备注',
            },
          ],
        };
      },
      // 应收结算单
      receivableSettlement() {
        return {
          API: SALE_INVOICE_API.RECIVE_SETTLEMENT_PAGE,
          propName: 'receivableSettlementNo', // 输入框展示内容
          propCode: 'receivableSettlementNo',
          query: {
            receivableSettlementNo: null,
          },
          extraData: {},
          searchColumns: [
            {
              prop: 'receivableSettlementNoLike',
              name: '结算单编号',
              type: 'input',
              placeholder: '请输入结算单编号',
            },
            {
              prop: 'customerNameLike',
              name: '客户名称',
              type: 'input',
              placeholder: '请输入客户名称',
            },
          ],
          columnList: [
            {
              prop: 'receivableSettlementNo',
              label: '结算单编号',
            },
            {
              prop: 'settlementCompanyName',
              label: '公司',
            },
            {
              prop: 'settlementDepartmentName',
              label: '部门',
            },
            {
              prop: 'domesticTotalAmount',
              label: '本币结算总金额',
            },
            {
              prop: 'customerName',
              label: '客户名称',
            },
            {
              prop: 'currencyName',
              label: '币种名称',
            },
            {
              prop: 'contractNo',
              label: '合同编号',
            },
            {
              prop: 'projectInitiationNo',
              label: '项目编码',
            },
            {
              prop: 'domesticTotalAmount',
              label: '未收款金额',
            },
            {
              prop: 'remark',
              label: '备注',
            },
          ],
        };
      }, // 应收结算单-到行信息
      receivableSettlementForLine() {
        return {
          API: SALE_INVOICE_API.RECIVE_SETTLEMENT_LINE_PAGE,
          propName: 'receivableSettlementNo', // 输入框展示内容
          propCode: 'receivableSettlementNo',
          query: {
            receivableSettlementNo: null,
            settlementStatus: '04',
            settlementBusinessType: '01',
          },
          extraData: {},
          searchColumns: [
            {
              prop: 'receivableSettlementNoLike',
              name: '结算单编号',
              type: 'input',
              placeholder: '请输入结算单编号',
            },
            {
              prop: 'settlementBusinessType',
              name: '贸易类型',
              type: 'select',
              options: this.dictListMap?.businessCategory,
            },
          ],
          columnList: [
            {
              prop: 'receivableSettlementNo',
              label: '结算单编号',
            },
            {
              prop: 'settlementCompanyName',
              label: '公司',
            },
            {
              prop: 'settlementDepartmentName',
              label: '部门',
            },
            {
              prop: 'originalAmount',
              label: '结算金额',
            },
            {
              prop: 'applyInvoiceAmount',
              label: '已开票金额',
            },
            {
              prop: 'currencyName',
              label: '币种名称',
            },
            {
              prop: 'settlementQuantity',
              label: '结算数量',
            },
            {
              prop: 'originalPrice',
              label: '结算单价',
            },
            {
              prop: 'contractNo',
              label: '合同编号',
            },
            {
              prop: 'customerName',
              label: '客户名称',
            },
            {
              prop: 'projectInitiationNo',
              label: '项目编码',
            },
            {
              prop: 'productName',
              label: '商品/服务描述',
            },
            {
              prop: 'remark',
              label: '备注',
            },
            {
              prop: 'settlementDesc',
              label: '结算说明',
            },
          ],
        };
      },
      // 应收结算单-主表（销售发票关联用）
      receivableSettlementBySaleInvoice() {
        return {
          API: SALE_INVOICE_API.RECIVE_SETTLEMENT_PAGE,
          propName: 'receivableSettlementNo', // 输入框展示内容
          propCode: 'receivableSettlementNo',
          query: {
            receivableSettlementNo: null,
          },
          extraData: {},
          searchColumns: [
            {
              prop: 'receivableSettlementNo',
              name: '结算单编号',
              type: 'input',
              placeholder: '请输入结算单编号',
            },
            {
              prop: 'settlementBusinessType',
              name: '贸易类型',
              type: 'select',
              options: this.dictListMap?.businessCategory,
            },
          ],
          columnList: [
            {
              prop: 'receivableSettlementNo',
              label: '结算单编号',
            },
            {
              prop: 'settlementCompanyName',
              label: '公司',
            },
            {
              prop: 'settlementDepartmentName',
              label: '部门',
            },
            {
              prop: 'domesticTotalAmount',
              label: '本币结算总金额',
            },
            {
              prop: 'customerName',
              label: '客户名称',
            },
            {
              prop: 'currencyName',
              label: '币种名称',
            },
            {
              prop: 'contractNo',
              label: '合同编号',
            },
            {
              prop: 'projectInitiationNo',
              label: '项目编码',
            },
            {
              prop: 'remark',
              label: '备注',
            },
          ],
        };
      },
      blueTicketTable() {
        return {
          labelWidth: '110px',
          query: {},
          API: SALE_INVOICE_API.BLUE_TICKET_API,
          columnList: [
            {
              prop: 'goldenInvoiceNumber',
              label: '销售发票编号',
            },
            {
              prop: 'goldenInvoiceCode',
              label: '销售发票代码',
            },
            {
              prop: 'invoiceCompanyName',
              label: '公司',
            },
            {
              prop: 'invoiceDepartmentName',
              label: '部门',
            },
            {
              prop: 'partnerCode',
              label: '客户编号',
            },
            {
              prop: 'partnerName',
              label: '客户名称',
            },
            {
              prop: 'invoiceCreateDate',
              label: '制单日期范围',
            },
          ],
        };
      },
      // 报修单
      repairOrder() {
        return {
          labelWidth: '110px',
          query: {
            repairNo: '',
            name: '',
            repairDepartmentNo: '',
            repairDateStart: '',
            repairDateEnd: '',
            repairPersonName: '',
          },
          API: REPAIRORDERAPI.REPAIR_QUERY,
          propName: 'repairNo', // 输入框展示内容
          propCode: 'repairNo',
          // extraData: {
          //   dispatchFlag: 20,
          //   auditStatus: '03',
          //   repairCompanyNo: this.userInfo.personCompanyCode,
          // },
          searchColumns: [
            {
              prop: 'repairNo',
              name: '报修单号',
              type: 'input',
            },
            {
              prop: 'name',
              name: '报修单名称',
              type: 'input',
            },
            {
              prop: 'repairDepartmentNo',
              name: '报修部门',
              type: 'select',
              options: this.departmentList,
            },
            {
              prop: 'repairDateStart',
              name: '报修开始日期',
              type: 'startDaterangePicker',
            },
            {
              prop: 'repairDateEnd',
              name: '报修结束日期',
              type: 'endDaterangePicker',
            },
            {
              prop: 'repairPersonName',
              name: '报修人',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'sortNo',
              label: '序号',
              width: 50,
            },
            {
              prop: 'repairNo',
              label: '报修单号',
            },
            {
              prop: 'name',
              label: '报修单名称',
            },
            {
              prop: 'repairDepartmentName',
              label: '报修部门',
            },
            {
              prop: 'repairPersonName',
              label: '报修人',
            },
            {
              prop: 'repairDate',
              label: '报修日期',
            },
            {
              prop: 'auditStatus',
              label: '审核状态',
            },
            {
              prop: 'dispatchFlagName',
              label: '是否派单',
            },
          ],
        };
      },
      // 多式联运-联动单位
      linkedCompany() {
        return {
          labelWidth: '110px',
          query: {
            // value: '',
            // label: '',
          },
          API: BASE_API.LISTDATA_DSLYSERECHCOMPANY,
          propName: 'label', // 输入框展示内容
          propCode: 'label',
          // extraData: {
          //   tenantCode:'1'
          // },
          searchColumns: [
            {
              prop: 'createCompanyName',
              name: '联动单位名称',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'value',
              label: '联动单位编号',
            },
            {
              prop: 'label',
              label: '联动单位名称',
            },
          ],
        };
      },
      liquidatedDamagesContract() {
        return {
          labelWidth: '110px',
          query: {
            // contractNo: '',
          },
          API: '/financial/statistic/overdue/queryOrderByPage',
          propName: 'contractNo', // 输入框展示内容
          propCode: 'contractNo',
          extraData: {
            contractStatus: 'ZT03',
          },
          searchColumns: [
            {
              name: '项目编号',
              prop: 'projectInitiationNo',
              type: 'input',
              disabled: true,
            },
            {
              name: this.$t('salePurchase.search.contractNo'),
              prop: 'contractNo',
              type: 'input',
            },
          ],
          columnList: [
            {
              prop: 'contractNo',
              label: this.$t('salePurchase.search.contractNo'),
              width: 266,
            },
            {
              prop: 'customerName',
              label: '客户名称',
              width: 266,
            },
            // {
            //   prop: 'contractStatusName',
            //   label: '合同状态',
            //   width: 266,
            // },
          ],
        };
      },
    },
    data() {
      return {
        defaultValue: this.currentValue,
        companyCode: null,
        departmentList: [], // 部门
        supplierList: [], //供应链主体
        searchTypeClone: null, //定义在控件内的searchType，用于根据条件切换不同控件
        settlementBusinessType: '01',
        dispatchFlag: 20, //保修单传递参数
      };
    },
    watch: {
      currentValue() {
        this.defaultValue = this.currentValue;
      },
      searchType: {
        handler(newV) {
          this.searchTypeClone = newV;
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.companyCode = this.userInfo.companyCode;
      this.getDepartment(this.companyCode);
      this.getSupply();
    },
    methods: {
      changeQuery(newValue) {
        if (this.searchType == 'receivableSettlementForLine') {
          if (newValue.settlementBusinessType == '01') {
            this.searchTypeClone = 'receivableSettlementForLine';
          } else {
            this.searchTypeClone = 'receivableSettlementBySaleInvoice';
          }
        }
      },
      formatterPartnerType({ cellValue }) {
        return this.$baseRequest.getDictValueByType('partner_type', cellValue);
      },
      formatterisDirectDeliver({ cellValue }) {
        return this.$baseRequest.getDictValueByType('yes-no', cellValue);
      },
      formatterDate({ cellValue }) {
        if (cellValue && cellValue.length != 0) {
          return XEUtils.toDateString(cellValue, 'yyyy-MM-dd');
        }
        return '';
      },
      formatterThirdPartyContractStatus({ cellValue }) {
        let map = {
          '01': '已保存',
          '02': '待审批',
          '03': '已生效',
          '04': '已驳回',
          '05': '已关闭',
          '06': '已到期',
          '07': '已结算',
        };
        return map[cellValue] ?? '';
      },
      formatterLeaseContractStatus({ cellValue }) {
        let contractStatusList = [
          { label: '待生效', value: '01' },
          { label: '生效中', value: '02' },
          { label: '已到期', value: '03' },
          { label: '已关闭', value: '04' },
        ];
        return contractStatusList.find((item) => item.value == cellValue)?.label ?? '';
      },
      formatterIntermodalityContractStatus({ cellValue }) {
        return this.$baseRequest.getDictValueByType('intermodality_contract_statu', cellValue);
      },
      formatterIntermodalityProjectStatus({ cellValue }) {
        return this.$baseRequest.getDictValueByType('INTERMODALITY-PROJECT-STATUS', cellValue);
      },
      formatterPropertyLeaseContractStatus({ cellValue }) {
        let contractStatusList = [
          { label: '待生效', value: '01' },
          { label: '生效中', value: '02' },
          { label: '已到期', value: '03' },
          { label: '已关闭', value: '04' },
          { label: '暂停', value: '05' },
        ];
        return contractStatusList.find((item) => item.value == cellValue)?.label ?? '';
      },
      formatterPropertyLeaseContractType({ cellValue }) {
        let contractTypeList = [
          { label: '租赁合同', value: '01' },
          { label: '物业合同', value: '02' },
        ];
        return contractTypeList.find((item) => item.value == cellValue)?.label ?? '';
      },
      //选值
      setSearchModal(type, row) {
        this.$emit('input', row);
      },
      //可以输入
      setSearchModalInput(type, val) {
        this.$emit('inputReadOnly', val);
      },
      // 重置
      resetClick() {
        this.defaultValue = this.currentValue;
        if (this.$refs.SearchModal) {
          this.$refs.SearchModal.resetClick();
        }
      },
      //关闭弹窗
      blurModal() {
        this.$refs.SearchModal.blurModal();
      },
      async getSupply() {
        // 获取供应链主体
        let params = this.$baseRequest.assignObj({
          requestStatus: 'ZT03',
          //personCompanyCode: companyCode
        });
        const selectStatus = await this.$axios.post(SUPPLY_API.LIST_SUPPLIERS, params);
        if (selectStatus.data.code == 0) {
          this.supplierList = selectStatus.data.data.map((item) => {
            return {
              value: item.supplierCode,
              label: item.supplierName,
            };
          });
        } else {
          this.supplierList = [];
        }
      },
      async getDepartment(companyCode) {
        // 取一级部门的最后一级部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            //personCompanyCode: companyCode
          };
          const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
            if (this.departmentList.length == 0) {
              this.$message({ showClose: true, message: '缺少对应部门，请维护', type: 'error' });
            }
          }
        } else {
          this.departmentList = [];
        }
      },
    },
  };
</script>
<style lang="scss"></style>
